import lz from '@lizhife/lz-jssdk';
import ua$2 from '@lizhife/ua';
import webReport from '@lizhife/web-report';
import Uploader from '@lizhife/upload-js-sdk';
import { mapGetters } from 'vuex';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ABANDONED_TAG = {
  FORM: 'FORM',
  RANK_LIST: 'RANK_LIST',
  BUTTON: 'BUTTON',
  PLAYER: 'PLAYER',
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO',
  ANIMATION: 'ANIMATION'
};
var TAG_PRESET = _objectSpread({
  VOD: 'VOD',
  LIVE: 'LIVE',
  ZY: 'ZY',
  COMMON: 'COMMON',
  SUGAR: 'SUGAR'
}, ABANDONED_TAG);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var setPrototypeOf = createCommonjsModule(function (module) {
  function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  module.exports = _setPrototypeOf;
});

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

var inherits = _inherits;

var _typeof_1 = createCommonjsModule(function (module) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      module.exports = _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      module.exports = _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  module.exports = _typeof;
});

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized;

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof_1(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

var possibleConstructorReturn = _possibleConstructorReturn;

var getPrototypeOf = createCommonjsModule(function (module) {
  function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  module.exports = _getPrototypeOf;
});

/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0;
/** `Object#toString` result references. */

var symbolTag = '[object Symbol]';
/** Used to match words composed of alphanumeric characters. */

var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/** Used to match Latin Unicode letters (excluding mathematical operators). */

var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */

var rsAstralRange = "\\ud800-\\udfff",
    rsComboMarksRange = "\\u0300-\\u036f\\ufe20-\\ufe23",
    rsComboSymbolsRange = "\\u20d0-\\u20f0",
    rsDingbatRange = "\\u2700-\\u27bf",
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = "\\u2000-\\u206f",
    rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = "\\ufe0e\\ufe0f",
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
/** Used to compose unicode capture groups. */

var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = "\\ud83c[\\udffb-\\udfff]",
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */

var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
/** Used to match apostrophes. */

var reApos = RegExp(rsApos, 'g');
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */

var reComboMark = RegExp(rsCombo, 'g');
/** Used to match complex or compound words. */

var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')', rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr, rsUpper + '+' + rsOptUpperContr, rsDigits, rsEmoji].join('|'), 'g');
/** Used to detect strings that need a more robust regexp to match words. */

var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/** Used to map Latin Unicode letters to basic Latin letters. */

var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',
  '\xc1': 'A',
  '\xc2': 'A',
  '\xc3': 'A',
  '\xc4': 'A',
  '\xc5': 'A',
  '\xe0': 'a',
  '\xe1': 'a',
  '\xe2': 'a',
  '\xe3': 'a',
  '\xe4': 'a',
  '\xe5': 'a',
  '\xc7': 'C',
  '\xe7': 'c',
  '\xd0': 'D',
  '\xf0': 'd',
  '\xc8': 'E',
  '\xc9': 'E',
  '\xca': 'E',
  '\xcb': 'E',
  '\xe8': 'e',
  '\xe9': 'e',
  '\xea': 'e',
  '\xeb': 'e',
  '\xcc': 'I',
  '\xcd': 'I',
  '\xce': 'I',
  '\xcf': 'I',
  '\xec': 'i',
  '\xed': 'i',
  '\xee': 'i',
  '\xef': 'i',
  '\xd1': 'N',
  '\xf1': 'n',
  '\xd2': 'O',
  '\xd3': 'O',
  '\xd4': 'O',
  '\xd5': 'O',
  '\xd6': 'O',
  '\xd8': 'O',
  '\xf2': 'o',
  '\xf3': 'o',
  '\xf4': 'o',
  '\xf5': 'o',
  '\xf6': 'o',
  '\xf8': 'o',
  '\xd9': 'U',
  '\xda': 'U',
  '\xdb': 'U',
  '\xdc': 'U',
  '\xf9': 'u',
  '\xfa': 'u',
  '\xfb': 'u',
  '\xfc': 'u',
  '\xdd': 'Y',
  '\xfd': 'y',
  '\xff': 'y',
  '\xc6': 'Ae',
  '\xe6': 'ae',
  '\xde': 'Th',
  '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  "\u0100": 'A',
  "\u0102": 'A',
  "\u0104": 'A',
  "\u0101": 'a',
  "\u0103": 'a',
  "\u0105": 'a',
  "\u0106": 'C',
  "\u0108": 'C',
  "\u010A": 'C',
  "\u010C": 'C',
  "\u0107": 'c',
  "\u0109": 'c',
  "\u010B": 'c',
  "\u010D": 'c',
  "\u010E": 'D',
  "\u0110": 'D',
  "\u010F": 'd',
  "\u0111": 'd',
  "\u0112": 'E',
  "\u0114": 'E',
  "\u0116": 'E',
  "\u0118": 'E',
  "\u011A": 'E',
  "\u0113": 'e',
  "\u0115": 'e',
  "\u0117": 'e',
  "\u0119": 'e',
  "\u011B": 'e',
  "\u011C": 'G',
  "\u011E": 'G',
  "\u0120": 'G',
  "\u0122": 'G',
  "\u011D": 'g',
  "\u011F": 'g',
  "\u0121": 'g',
  "\u0123": 'g',
  "\u0124": 'H',
  "\u0126": 'H',
  "\u0125": 'h',
  "\u0127": 'h',
  "\u0128": 'I',
  "\u012A": 'I',
  "\u012C": 'I',
  "\u012E": 'I',
  "\u0130": 'I',
  "\u0129": 'i',
  "\u012B": 'i',
  "\u012D": 'i',
  "\u012F": 'i',
  "\u0131": 'i',
  "\u0134": 'J',
  "\u0135": 'j',
  "\u0136": 'K',
  "\u0137": 'k',
  "\u0138": 'k',
  "\u0139": 'L',
  "\u013B": 'L',
  "\u013D": 'L',
  "\u013F": 'L',
  "\u0141": 'L',
  "\u013A": 'l',
  "\u013C": 'l',
  "\u013E": 'l',
  "\u0140": 'l',
  "\u0142": 'l',
  "\u0143": 'N',
  "\u0145": 'N',
  "\u0147": 'N',
  "\u014A": 'N',
  "\u0144": 'n',
  "\u0146": 'n',
  "\u0148": 'n',
  "\u014B": 'n',
  "\u014C": 'O',
  "\u014E": 'O',
  "\u0150": 'O',
  "\u014D": 'o',
  "\u014F": 'o',
  "\u0151": 'o',
  "\u0154": 'R',
  "\u0156": 'R',
  "\u0158": 'R',
  "\u0155": 'r',
  "\u0157": 'r',
  "\u0159": 'r',
  "\u015A": 'S',
  "\u015C": 'S',
  "\u015E": 'S',
  "\u0160": 'S',
  "\u015B": 's',
  "\u015D": 's',
  "\u015F": 's',
  "\u0161": 's',
  "\u0162": 'T',
  "\u0164": 'T',
  "\u0166": 'T',
  "\u0163": 't',
  "\u0165": 't',
  "\u0167": 't',
  "\u0168": 'U',
  "\u016A": 'U',
  "\u016C": 'U',
  "\u016E": 'U',
  "\u0170": 'U',
  "\u0172": 'U',
  "\u0169": 'u',
  "\u016B": 'u',
  "\u016D": 'u',
  "\u016F": 'u',
  "\u0171": 'u',
  "\u0173": 'u',
  "\u0174": 'W',
  "\u0175": 'w',
  "\u0176": 'Y',
  "\u0177": 'y',
  "\u0178": 'Y',
  "\u0179": 'Z',
  "\u017B": 'Z',
  "\u017D": 'Z',
  "\u017A": 'z',
  "\u017C": 'z',
  "\u017E": 'z',
  "\u0132": 'IJ',
  "\u0133": 'ij',
  "\u0152": 'Oe',
  "\u0153": 'oe',
  "\u0149": "'n",
  "\u017F": 'ss'
};
/** Detect free variable `global` from Node.js. */

var freeGlobal = _typeof_1(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
/** Detect free variable `self`. */

var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof_1(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */

function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }

  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }

  return accumulator;
}
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */


function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */


function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */


var deburrLetter = basePropertyOf(deburredLetters);
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */

function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */


function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}
/** Used for built-in method references. */


var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString = objectProto.toString;
/** Built-in value references. */

var _Symbol = root.Symbol;
/** Used to convert symbols to primitives and strings. */

var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */


function createCompounder(callback) {
  return function (string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike(value) {
  return !!value && _typeof_1(value) == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */


function isSymbol(value) {
  return _typeof_1(value) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */


function toString(value) {
  return value == null ? '' : baseToString(value);
}
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */


function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */


var kebabCase = createCompounder(function (result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */

function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }

  return string.match(pattern) || [];
}

var lodash_kebabcase = kebabCase;

var runtime_1 = createCommonjsModule(function (module) {
  var runtime = function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && _typeof_1(value) === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});

var regenerator = runtime_1;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var asyncToGenerator = _asyncToGenerator;

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var arrayWithHoles = _arrayWithHoles;

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

var iterableToArrayLimit = _iterableToArrayLimit;

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var arrayLikeToArray = _arrayLikeToArray;

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

var unsupportedIterableToArray = _unsupportedIterableToArray;

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var nonIterableRest = _nonIterableRest;

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

var slicedToArray = _slicedToArray;

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var EDITOR_TYPE = {
  STRING: 'string',
  BOOLEAN: 'boolean',
  NUMBER: 'number',
  LAYOUT: 'box-editor',
  SLOT: 'slot',
  COLOR: 'color',
  SELECT: 'select',
  CUSTOM: 'custom',
  UPLOAD: 'upload',
  EVENT: 'event',
  NAMED_SLOT: 'named_slot'
};
var EVENT_TYPE = {
  INIT: 'init',
  SHOW: 'show',
  HIDE: 'hide',
  UPDATE: 'update',
  DESTROY: 'destroy'
};
var isHttps = location.protocol.indexOf('https') > -1;

function addImmutableProp(obj, key, val) {
  var description = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (process.env.isUnderJest) {
    obj[key] = val;
    return;
  }

  var options = _objectSpread$1({
    configurable: false,
    enumerable: true,
    writable: false,
    value: val
  }, description);

  if (typeof options.get === 'function') {
    delete options.value;
    delete options.writable;
  }

  Object.defineProperty(obj, key, options);
}

function queryToObj(queryStr) {
  var ret = {};
  var list = queryStr.split('&');

  for (var i = 0; i < list.length; i++) {
    var _list$i = slicedToArray(list[i], 2),
        key = _list$i[0],
        value = _list$i[1];

    ret[key] = value;
  }

  return ret;
}

var ua = window.navigator.userAgent; // 获取主域名

var getMainHost = function getMainHost(host) {
  return host.split('.').slice(-2).join('.');
};
/**
 * 放置一些用于跨页面的的动作
 */

/**
 * 解析页面 URL 上面的 scrollTo 参数，并滚动到页面指定位置
 */


function parseScrollQuery(container) {
  var search = window.location.search;

  var _queryToObj = queryToObj(search),
      scrollTop = _queryToObj.scrollTop;

  scrollTo(scrollTop, container);
}
/**
 * 解析 页面 local storage 里面的 scrollTo 参数，并滚动到页面指定位置
 */


function parseScrollLS(container) {
  var px = window.localStorage.getItem('scrollTop');
  scrollTo(px, container);
  window.localStorage.removeItem('scrollTop');
} // NOTE: 在 vue 里面最上层的 component 的 mounted 里用 nextTick 去执行 scroll 逻辑没有效果。只能暂时用轮询 dom 高度的办法。


function scrollTo(px, container) {
  var prevHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 9;

  if (!px) {
    return;
  }

  px = Number(px);

  if (typeof px === 'number' && isNaN(px) === false) {
    var curHeight = container.offsetHeight;

    if (curHeight !== prevHeight || window.document.readyState !== 'complete') {
      setTimeout(function () {
        scrollTo(px, container, curHeight);
      }, 300);
    } else {
      window.scrollTo(0, px);
    }
  }
}

var event = {};

function getHandlerListViaKey(eventType, key) {
  if (event[eventType] == null) {
    event[eventType] = {};
  }

  if (event[eventType][key] == null) {
    event[eventType][key] = [];
  }

  return event[eventType][key];
}

function getHandlerListViaVm(eventType, vm) {
  var vmKey;

  try {
    vmKey = vm.$vnode.data.key;
  } catch (e) {
    vmKey = vm._uid;
  }

  return getHandlerListViaKey(eventType, vmKey);
}

function getHandlerListViaKeyList(eventType, keyList) {
  var handlerListContainer = keyList.map(function (key) {
    return getHandlerListViaKey(eventType, key);
  });
  return handlerListContainer.reduce(function (a, b) {
    return a.concat(b);
  }, []);
}

function onEvent(eventType, vm, handler) {
  if (EVENT_TYPE[eventType.toUpperCase()] == null) {
    throw new Error('不支持事件 ' + eventType + ' 的监听，具体支持的事件类型参考文档。');
  }

  var listenerList = getHandlerListViaVm(eventType, vm); // NOTE: 暂时只允许一个监听函数

  if (listenerList.length === 1) {
    listenerList[0] = handler;
  } else {
    listenerList.push(handler);
  }
}

function emitEvent(eventType) {
  var eventTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (EVENT_TYPE[eventType.toUpperCase()] == null) {
    throw new Error('不支持事件 ' + eventType + ' 的监听，具体支持的事件类型参考文档。');
  }

  var listenerList = getHandlerListViaKeyList(eventType, eventTarget);

  for (var _len = arguments.length, data = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    data[_key - 2] = arguments[_key];
  }

  for (var i = 0; i < listenerList.length; i++) {
    try {
      listenerList[i](_objectSpread$1({
        targetId: eventTarget[i]
      }, data || {}));
    } catch (e) {
      console.error(e);
    }
  }
}

function offEvent(eventType, vm, handler) {
  if (EVENT_TYPE[eventType.toUpperCase()] == null) {
    throw new Error('不支持事件 ' + eventType + ' 的监听，具体支持的事件类型参考文档。');
  }

  var listenerList = getHandlerListViaVm(eventType, vm);
  var index = listenerList.indexOf(handler);

  if (index === -1) {
    return;
  }

  return listenerList.splice(index, 1);
}

var apiList = ['getToken', 'getAppInfo', 'getDisplayInfo', 'getSessionUser', 'shareUrl', 'playProgram', 'scanUser', 'showOrHideBottomPlayer', 'gotoLogin', 'showCommentMenu', 'showOrHideBottomInput', 'downloadMaterial', 'getDownloadMaterialStatus', 'isSupportFunc', 'closeWebView', 'scanRechargeCenter', 'toAction', 'getWebDisplayInfo', 'setAppDisplayInfo', 'startRecordVoice', 'stopRecordVoice', 'shareImage', 'showGivePresent', 'reportEvent', 'getUdid', 'requestVerifySign', 'requestBuyProduct', 'requestTradeProduct', 'getSupportedPaymentTypeList', 'saveImage', 'configShareUrl', 'replayRecordVoice', 'uploadRecordVoice', 'updateHotProgressVisible', 'gotoRegister', 'shareImageUrl', 'selectedSong', 'getSelectedSongStatus', 'configNativeLivePK', 'showPrompt', 'showAlert', 'phoneRiskResult', 'popupLiveGiftDialog', 'stopAllAudioPlay', 'bindThreePartyPlatform', 'webTraceReport', 'holdLocks', 'getValidCdnHost', 'realWidgetsLayoutChanged', 'playSoundEffect', 'requestReportAction', 'openSystemPermissionSetting', 'getABTestConfig', 'getAppId', 'queryAndroidThirdPackageState', 'operateAndroidThirdPackage', 'setFloatDownloadManagerVisibility'];
var eventList = ['user:login', 'comment:success', 'downloadMaterial:status', 'hitsTrade', 'visible', 'recordStateChange', 'givePresentSuccess', 'verifySignFinish', 'buyProductFinish', 'payFinish', 'tradeProductFinish', 'updateLivePKInfo', 'selectedSong:status', 'shareFinish', 'nativeLayoutChanged', 'liveGiftDialogDisplayStatusChanged'];
var configUrl = "https://h5security.".concat(getMainHost(location.host), "/jsBridgeConfig/get");
var apiList$1 = ['log', 'getSessionUser', 'toAction', 'getToken', 'showPrompt', 'isSupportFunc', 'closeWebView', 'playUrl', 'stopPlayUrl', 'finishAnalysis', 'getSessionUserId', 'getUdid', 'requestVerifySign', 'getAppInfo', 'saveImage', 'notification', 'isSupportShare', 'shareImage', 'traceReport', 'finishUseItem', 'afInviteUrl', 'getLiveParam'];
var eventList$1 = ['playUrlStatus', 'verifySignFinish', 'viewLifeCycleStatus'];
var configUrl$1 = 'https://h5.zyapp.cn/jsbridge/generator';
var configUrl$2 = 'https://h5zy.tiyalive.com/jsbridge/generator';
var configUrl$3 = 'https://h5security.183me.com/jsBridgeConfig/get';
var configUrl$4 = 'https://h5security.pparty.com/jsBridgeConfig/get';
var configUrl$5 = 'https://client.lzpipi.com/jsBridgeConfig/get';

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ua$1 = navigator.userAgent || ''; // 版本号比较

var semverCompare = function semverCompare(verionA, versionB) {
  // eslint-disable-next-line no-restricted-properties
  var _window = window,
      isNaN = _window.isNaN;
  var splitA = verionA.split('.');
  var splitB = versionB.split('.');

  for (var i = 0; i < 3; i++) {
    var snippetA = Number(splitA[i]);
    var snippetB = Number(splitB[i]);
    if (snippetA > snippetB) return 1;
    if (snippetB > snippetA) return -1; // e.g. '1.0.0-rc' -- Number('0-rc') = NaN

    if (!isNaN(snippetA) && isNaN(snippetB)) return 1;
    if (isNaN(snippetA) && !isNaN(snippetB)) return -1;
  }

  return 0;
};
/**
 * 获取 ios 大版本号
 */


var getIOSVersion = function getIOSVersion() {
  var version = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
  return Number.parseInt(version[1], 10);
};
/**
 * 获取 微信 版本号
 */


var getWeChatVersion = function getWeChatVersion() {
  var version = navigator.appVersion.match(/micromessenger\/(\d+\.\d+\.\d+)/i);
  return version[1];
};

var isAndroid = /android/i.test(ua$1);
var isIos = /iphone|ipad|ipod/i.test(ua$1);
var isWechat = /micromessenger\/([\d.]+)/i.test(ua$1);
var isWeibo = /(weibo).*weibo__([\d.]+)/i.test(ua$1);
var isBaidu = /(baiduboxapp)\/([\d.]+)/i.test(ua$1);
var isQQ = /qq\/([\d.]+)/i.test(ua$1);
var isQQBrowser = /(qqbrowser)\/([\d.]+)/i.test(ua$1);
var isQzone = /qzone\/.*_qz_([\d.]+)/i.test(ua$1); // 安卓 chrome 浏览器，包含 原生chrome浏览器、三星自带浏览器、360浏览器以及早期国内厂商自带浏览器

var isOriginalChrome = /chrome\/[\d.]+ mobile safari\/[\d.]+/i.test(ua$1) && isAndroid && ua$1.indexOf('Version') < 0; // 生成基本的 url scheme

function buildScheme(config, options) {
  var path = config.path,
      param = config.param;
  var customBuildScheme = options.buildScheme;

  if (typeof customBuildScheme !== 'undefined') {
    return customBuildScheme(config, options);
  }

  var _options$scheme = options.scheme,
      host = _options$scheme.host,
      port = _options$scheme.port,
      protocol = _options$scheme.protocol;
  var portPart = port ? ":".concat(port) : '';
  var hostPort = host ? "".concat(host).concat(portPart, "/") : '';
  var query = typeof param !== 'undefined' ? Object.keys(param).map(function (key) {
    return "".concat(key, "=").concat(param[key]);
  }).join('&') : '';
  var urlQuery = query ? "?".concat(query) : '';
  return "".concat(protocol, "://").concat(hostPort).concat(path).concat(urlQuery);
} // 生成业务需要的 url scheme（区分是否是外链）


function generateScheme(config, options) {
  var outChain = options.outChain;
  var uri = buildScheme(config, options);

  if (typeof outChain !== 'undefined' && outChain) {
    var protocol = outChain.protocol,
        path = outChain.path,
        key = outChain.key;
    uri = "".concat(protocol, "://").concat(path, "?").concat(key, "=").concat(encodeURIComponent(uri));
  }

  return uri;
} // 生成 android intent


function generateIntent(config, options) {
  var outChain = options.outChain;
  var intent = options.intent,
      fallback = options.fallback;
  if (typeof intent === 'undefined') return '';
  var keys = Object.keys(intent);
  var intentParam = keys.map(function (key) {
    return "".concat(key, "=").concat(intent[key], ";");
  }).join('');
  var intentTail = "#Intent;".concat(intentParam, "S.browser_fallback_url=").concat(encodeURIComponent(fallback), ";end;");
  var urlPath = buildScheme(config, options);

  if (typeof outChain !== 'undefined' && outChain) {
    var path = outChain.path,
        key = outChain.key;
    return "intent://".concat(path, "?").concat(key, "=").concat(encodeURIComponent(urlPath)).concat(intentTail);
  }

  urlPath = urlPath.slice(urlPath.indexOf('//') + 2);
  return "intent://".concat(urlPath).concat(intentTail);
} // 生成 universalLink


function generateUniversalLink(config, options) {
  var universal = options.universal;
  if (typeof universal === 'undefined') return '';
  var host = universal.host,
      pathKey = universal.pathKey;
  var path = config.path,
      param = config.param;
  var query = typeof param !== 'undefined' ? Object.keys(param).map(function (key) {
    return "".concat(key, "=").concat(param[key]);
  }).join('&') : '';
  var urlQuery = query ? "&".concat(query) : '';
  return "https://".concat(host, "?").concat(pathKey, "=").concat(path).concat(urlQuery);
} // 生成 应用宝链接


function generateYingYongBao(config, options) {
  var url = generateScheme(config, options); // 支持 AppLink

  return "".concat(options.yingyongbao, "&android_schema=").concat(encodeURIComponent(url));
}

var hidden;
var visibilityChange;
var iframe;

function getSupportedProperty() {
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }
}

getSupportedProperty();
/**
 * 判断页面是否隐藏（进入后台）
 */

function isPageHidden() {
  if (typeof hidden === 'undefined') return false;
  return document[hidden];
}
/**
 * 通过 top.location.href 跳转
 * @param {string}} [uri] - 需要打开的地址
 */


function evokeByLocation(uri) {
  window.top.location.href = uri;
}
/**
 * 通过 A 标签唤起
 * @param {string} uri - 需要打开的地址
 */


function evokeByTagA(uri) {
  var tagA = document.createElement('a');
  tagA.setAttribute('href', uri);
  tagA.style.display = 'none';
  document.body.append(tagA);
  tagA.click();
}
/**
 * 通过 iframe 唤起
 * @param {string} [uri] - 需要打开的地址
 */


function evokeByIFrame(uri) {
  if (!iframe) {
    iframe = document.createElement('iframe');
    iframe.frameBorder = '0';
    iframe.style.cssText = 'display:none;border:0;width:0;height:0;';
    document.body.append(iframe);
  }

  iframe.src = uri;
}
/**
 * 检测是否唤端成功
 * @param cb - 唤端失败回调函数
 * @param timeout
 */


function checkOpen(failure, timeout) {
  var timer = setTimeout(function () {
    var pageHidden = isPageHidden();

    if (!pageHidden) {
      failure();
    }
  }, timeout);

  if (typeof visibilityChange !== 'undefined') {
    document.addEventListener(visibilityChange, function () {
      clearTimeout(timer);
    });
  } else {
    window.addEventListener('pagehide', function () {
      clearTimeout(timer);
    });
  }
}

var CallApp = /*#__PURE__*/function () {
  // Create an instance of CallApp
  function CallApp(options) {
    _classCallCheck$1(this, CallApp);

    _defineProperty$1(this, "options", void 0);

    var defaultOptions = {
      timeout: 2000
    };
    this.options = _extends(defaultOptions, options);
  }
  /**
   * 注册为方法
   * generateScheme | generateIntent | generateUniversalLink | generateYingYongBao | checkOpen
   */


  _createClass$1(CallApp, [{
    key: "generateScheme",
    value: function generateScheme$1(config) {
      return generateScheme(config, this.options);
    }
  }, {
    key: "generateIntent",
    value: function generateIntent$1(config) {
      return generateIntent(config, this.options);
    }
  }, {
    key: "generateUniversalLink",
    value: function generateUniversalLink$1(config) {
      return generateUniversalLink(config, this.options);
    }
  }, {
    key: "generateYingYongBao",
    value: function generateYingYongBao$1(config) {
      return generateYingYongBao(config, this.options);
    }
  }, {
    key: "checkOpen",
    value: function checkOpen$1(failure) {
      var _this$options = this.options,
          logFunc = _this$options.logFunc,
          timeout = _this$options.timeout;
      return checkOpen(function () {
        if (typeof logFunc !== 'undefined') {
          logFunc('failure');
        }

        failure();
      }, timeout);
    } // 唤端失败跳转 app store

  }, {
    key: "fallToAppStore",
    value: function fallToAppStore() {
      var _this = this;

      this.checkOpen(function () {
        evokeByLocation(_this.options.appstore);
      });
    } // 唤端失败跳转通用(下载)页

  }, {
    key: "fallToFbUrl",
    value: function fallToFbUrl() {
      var _this2 = this;

      this.checkOpen(function () {
        evokeByLocation(_this2.options.fallback);
      });
    } // 唤端失败调用自定义回调函数

  }, {
    key: "fallToCustomCb",
    value: function fallToCustomCb(callback) {
      this.checkOpen(function () {
        callback();
      });
    }
    /**
     * 唤起客户端
     * 根据不同 browser 执行不同唤端策略
     */

  }, {
    key: "open",
    value: function open(config) {
      var _this$options2 = this.options,
          universal = _this$options2.universal,
          appstore = _this$options2.appstore,
          logFunc = _this$options2.logFunc,
          intent = _this$options2.intent;
      var callback = config.callback;
      var supportUniversal = typeof universal !== 'undefined';
      var schemeURL = this.generateScheme(config);
      var checkOpenFall;

      if (typeof logFunc !== 'undefined') {
        logFunc('pending');
      }

      if (isIos) {
        // ios qq 禁止了 universalLink 唤起app，安卓不受影响 - 18年12月23日
        // ios qq 浏览器禁止了 universalLink - 19年5月1日
        // ios 微信自 7.0.5 版本放开了 Universal Link 的限制
        // ios 微博禁止了 universalLink
        if (isWechat && semverCompare(getWeChatVersion(), '7.0.5') === -1 || isWeibo) {
          evokeByLocation(appstore);
        } else if (getIOSVersion() < 9) {
          evokeByIFrame(schemeURL);
          checkOpenFall = this.fallToAppStore;
        } else if (!supportUniversal || isQQ || isQQBrowser || isQzone) {
          evokeByTagA(schemeURL);
          checkOpenFall = this.fallToAppStore;
        } else {
          evokeByLocation(this.generateUniversalLink(config));
        } // Android
        // 在微信中且配置了应用宝链接

      } else if (isWechat && typeof this.options.yingyongbao !== 'undefined') {
        evokeByLocation(this.generateYingYongBao(config));
      } else if (isOriginalChrome) {
        if (typeof intent !== 'undefined') {
          evokeByLocation(this.generateIntent(config));
        } else {
          // scheme 在 andriod chrome 25+ 版本上iframe无法正常拉起
          evokeByLocation(schemeURL);
          checkOpenFall = this.fallToFbUrl;
        }
      } else if (isWechat || isBaidu || isWeibo || isQzone) {
        evokeByLocation(this.options.fallback);
      } else {
        evokeByIFrame(schemeURL);
        checkOpenFall = this.fallToFbUrl;
      }

      if (typeof callback !== 'undefined') {
        this.fallToCustomCb(callback);
        return;
      }

      if (!checkOpenFall) return;
      checkOpenFall.call(this);
    }
  }]);

  return CallApp;
}();

function fetch$1(e, n) {
  return n = n || {}, new Promise(function (t, r) {
    var s = new XMLHttpRequest(),
        o = [],
        u = [],
        i = {},
        a = function a() {
      return {
        ok: 2 == (s.status / 100 | 0),
        statusText: s.statusText,
        status: s.status,
        url: s.responseURL,
        text: function text() {
          return Promise.resolve(s.responseText);
        },
        json: function json() {
          return Promise.resolve(s.responseText).then(JSON.parse);
        },
        blob: function blob() {
          return Promise.resolve(new Blob([s.response]));
        },
        clone: a,
        headers: {
          keys: function keys() {
            return o;
          },
          entries: function entries() {
            return u;
          },
          get: function get(e) {
            return i[e.toLowerCase()];
          },
          has: function has(e) {
            return e.toLowerCase() in i;
          }
        }
      };
    };

    for (var l in s.open(n.method || "get", e, !0), s.onload = function () {
      s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (e, n, t) {
        o.push(n = n.toLowerCase()), u.push([n, t]), i[n] = i[n] ? i[n] + "," + t : t;
      }), t(a());
    }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers) {
      s.setRequestHeader(l, n.headers[l]);
    }

    s.send(n.body || null);
  });
}

var isApp = /lizhifm|tiya|zhiya|pongpong|lizhigame|pplive|lizhilive|dahongpao/ig.test(window.navigator.userAgent);

var urlParser = function urlParser(url) {
  var a = document.createElement('a');
  a.href = decodeURIComponent(url);

  var search = function search(_search) {
    if (!_search) return {};
    var ret = {};

    if (_search.startsWith('?')) {
      _search = _search.slice(1);
    }

    _search = _search.split('&');

    for (var i = 0, arr; i < _search.length; i++) {
      arr = _search[i].split('=');
      var key = arr[0];
      var value = arr[1];

      if (/\[\]$/.test(key)) {
        ret[key] = ret[key] || [];
        ret[key].push(value);
      } else {
        ret[key] = value;
      }
    }

    return ret;
  };

  return {
    protocol: a.protocol,
    host: a.host,
    hostname: a.hostname,
    pathname: a.pathname,
    search: search(a.search.replace(/amp;/g, '')),
    // NOTE 目前单点有这样一个问题，backURL如果不使用decodeURIComponent，则search参数会丢失，如果使用，则会在&连接处加多amp;字符，parse的时候需要去掉,
    hash: a.hash,
    hashQuery: search(a.hash && a.hash.replace(/amp;/g, '').split('?')[1])
  };
};

function getAppUserInfo() {
  return new Promise(function (resolve, reject) {
    var timeoutTimer = setTimeout(function () {
      var reason = {
        status: 'failed',
        msg: '请求 app 接口超时'
      };
      reject(reason);
    }, 5000);
    proxy.getSessionUser({}, function (ret) {
      clearTimeout(timeoutTimer);

      if (ret.id) {
        return resolve(ret);
      }

      reject(ret);
    });
  });
}

function getAppDeviceInfo() {
  return new Promise(function (resolve, reject) {
    var timeoutTimer = setTimeout(function () {
      var reason = {
        status: 'failed',
        msg: '请求 app 接口超时'
      };
      reject(reason);
    }, 5000);
    proxy.getAppInfo({}, function (ret) {
      clearTimeout(timeoutTimer);

      if (ret.status === 'success') {
        return resolve(ret);
      }

      reject(ret);
    });
  });
}

function getActivityInfo() {
  var activityInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Promise.resolve(activityInfo);
}

function getUrlData() {
  return Promise.resolve(urlParser(window.location.href));
}

function getAppInfo() {
  var baseInfo = {
    isApp: isApp
  };

  if (isApp) {
    return new Promise(function (resolve, reject) {
      // 只有https才会执行getAppUserInfo
      // if (!isHttps) {
      //   return resolve(baseInfo)
      // }
      Promise.all([getAppUserInfo(), getAppDeviceInfo()]).then(function (_ref) {
        var _ref2 = slicedToArray(_ref, 2),
            userInfo = _ref2[0],
            appInfo = _ref2[1];

        resolve(_objectSpread$1(_objectSpread$1(_objectSpread$1({
          isLogin: userInfo.id
        }, userInfo), baseInfo), {}, {
          userInfo: userInfo,
          appInfo: appInfo
        }));
      })["catch"](function (e) {
        resolve(baseInfo);
      });
    });
  }

  return Promise.resolve(baseInfo);
}

function defineUnwritableProp(o, prop, value) {
  var description = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  Object.defineProperty(o, prop, _objectSpread$1(_objectSpread$1({
    writable: false,
    configurable: false
  }, description), {}, {
    value: value
  }));
  return o;
}

var store = {};
defineUnwritableProp(store, 'state', {});
defineUnwritableProp(store, 'getState', function (vm) {
  var componentName;

  if (vm == null) {
    return {};
  }

  if (typeof vm === 'string') {
    componentName = vm;
  } else if (vm.$options == null || vm.$options.componentName == null) {
    return {};
  } else {
    componentName = vm.$options.componentName;
  }

  if (store.state[componentName] == null) {
    defineUnwritableProp(store.state, componentName, {});
  }

  return store.state[componentName];
});

function initStore(activityInfo) {
  var promise;

  if (store.initPromise) {
    return store.initPromise;
  }

  promise = Promise.all([getUrlData(), getActivityInfo(activityInfo), getAppInfo()]).then(function (_ref3) {
    var _ref4 = slicedToArray(_ref3, 3),
        urlData = _ref4[0],
        activityInfo = _ref4[1],
        lizhiState = _ref4[2];

    var data = {
      url: Object.freeze(urlData),
      activity: Object.freeze(activityInfo),
      lizhi: Object.freeze(lizhiState)
    };
    defineUnwritableProp(store, 'globalData', Object.freeze(data));
    return store.globalData;
  });
  defineUnwritableProp(store, 'initPromise', promise, {
    enumerable: false
  });
  return promise;
}

function getStore(vm) {
  var state = store.getState(vm);

  if (store.globalData) {
    return Promise.resolve({
      globalData: store.globalData,
      state: state
    });
  }

  var promise = store.initPromise; // 会在导出代码那里先 initStore，但是这里还是加一个容错

  if (promise == null) {
    promise = initStore({});
  }

  return promise.then(function (globalData) {
    return {
      globalData: globalData,
      state: state
    };
  });
} // * 神策打点，初始化神策sdk，Promise 抛出


var INIT_STATUS = {
  NONE: 'NONE',
  PENDING: 'PENDING',
  FINISH: 'FINISH'
};
var initStatus = INIT_STATUS.NONE;
var sensors = null;
var resolveList = [];

function initSensors() {
  return _initSensors.apply(this, arguments);
}

function _initSensors() {
  _initSensors = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
    var initOpt, baseConfig, initConfig;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(!appConfig || !appConfig.sensorsUrl)) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", null);

          case 2:
            if (!(initStatus === INIT_STATUS.FINISH)) {
              _context4.next = 4;
              break;
            }

            return _context4.abrupt("return", sensors);

          case 4:
            initStatus = INIT_STATUS.PENDING;
            initOpt = appConfig.sensorsInitConfig || {}; // 按需加载

            if (sensors) {
              _context4.next = 10;
              break;
            }

            _context4.next = 9;
            return import(
            /* webpackChunkName: "thunk-sa-sdk" */
            'sa-sdk-javascript');

          case 9:
            sensors = _context4.sent;

          case 10:
            baseConfig = {
              server_url: appConfig.sensorsUrl,
              is_track_device_id: true,
              //  开启设备id采集
              app_js_bridge: true,
              // 配置打通 App 与 H5 的参数
              heatmap: {
                //是否开启点击图，默认为 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
                //需要 Web JS SDK 版本号大于 1.7
                clickmap: 'not_collect',
                //是否开启触达注意力图，默认 not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启
                //需要 Web JS SDK 版本号大于 1.9.1
                scroll_notice_map: 'not_collect'
              }
            };
            initConfig = _objectSpread$1(_objectSpread$1({}, baseConfig), initOpt);
            sensors.init(initConfig);
            return _context4.abrupt("return", new Promise(function (resolve) {
              sensors.quick('isReady', /*#__PURE__*/asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
                var _yield$getStore, globalData, autoTrackParams, commonParam, _yield$Promise$all, _yield$Promise$all2, user, appInfo, distinctId;

                return regenerator.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        console.log('sensors isReady');
                        _context3.next = 3;
                        return getStore();

                      case 3:
                        _yield$getStore = _context3.sent;
                        globalData = _yield$getStore.globalData;
                        autoTrackParams = {
                          act_activity_id: globalData.activity.id,
                          act_activity_name: globalData.activity.title,
                          act_inviter: globalData.url.search.act_inviter,
                          act_source: globalData.url.search.act_source,
                          act_sub_source: globalData.url.search.act_sub_source,
                          act_platformid: globalData.url.search.platformid
                        };
                        commonParam = {};

                        if (!lz.isApp) {
                          _context3.next = 18;
                          break;
                        }

                        _context3.next = 10;
                        return Promise.all([lz.getSessionUser(), lz.getAppInfo()]);

                      case 10:
                        _yield$Promise$all = _context3.sent;
                        _yield$Promise$all2 = slicedToArray(_yield$Promise$all, 2);
                        user = _yield$Promise$all2[0];
                        appInfo = _yield$Promise$all2[1];
                        autoTrackParams.app_device_id = appInfo.deviceId;
                        distinctId = user && user.id ? user.id : ''; // 如果用户登录则使用userId 否则使用deviceId

                        if (distinctId) {
                          sensors.login(distinctId);
                        } // 监听用户登录状态变化


                        if (!user || user && !user.id) {
                          lz.on('user:loginStateChanged', function (ret) {
                            // 检测到用户登录 主动login
                            if (ret && ret.userId) {
                              sensors.login(ret.userId);
                            } else {
                              // 用户登出 主动logout
                              sensors.logout();
                            }
                          });
                        }

                      case 18:
                        // 注册公共属性
                        sensors.registerPage(commonParam);
                        sensors.quick('autoTrack', {
                          report_json: JSON.stringify(_objectSpread$1({}, autoTrackParams))
                        });
                        initStatus = INIT_STATUS.FINISH;
                        resolve(sensors);

                        if (resolveList.length) {
                          resolveList.forEach(function (resolve) {
                            return resolve(sensors);
                          });
                        }

                      case 23:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              })));
            }));

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _initSensors.apply(this, arguments);
}

function getSensors() {
  console.log('getSensors', initStatus);
  return new Promise(function (resolve) {
    if (initStatus === INIT_STATUS.NONE) {
      resolve(null);
    } else if (initStatus === INIT_STATUS.FINISH) {
      resolve(sensors);
    } else {
      resolveList.push(resolve);
    }
  });
}
/**
 * 口令接口
 */


var TOKEN_HOST = 'https://command.lizhi.fm';
var defaultOption = {
  ulinkPrefix: 'https://link.lizhi.fm/ulink',
  urlSchemePrefix: 'lizhifm://',
  yybLink: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.yibasan.lizhifm'
};

var AppInvoker = /*#__PURE__*/function () {
  function AppInvoker() {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    classCallCheck(this, AppInvoker);

    option = _objectSpread$1(_objectSpread$1({}, defaultOption), option);
    this.ua = {
      iPhone: ua$2.isIOS(),
      iPod: ua$2.isIOS(),
      iPad: ua$2.isIOS(),
      android: ua$2.isAndroid(),
      qqBrowser: window.navigator.userAgent.indexOf('MQQBrowser') > -1,
      quarkBrowser: window.navigator.userAgent.indexOf('Quark') > -1,
      wx: ua$2.isWeixin(),
      qq: /QQ\//i.test(window.navigator.userAgent),
      weibo: window.navigator.userAgent.toLowerCase().indexOf('weibo') > -1,
      isApp: ua$2.isLizhiFM()
    };
    this.appName = option.appName; // 维护口令

    this.tokenMap = {}; // 维护action

    this.actionMap = {};
    this.URL_ULINK = option.ulinkPrefix;
    this.URL_SCHEMA = option.urlSchemePrefix; // note: 这条在别的 app 应该无效

    this.URL_IOS_ACTION = "".concat(option.urlSchemePrefix, "www.lizhi.fm?clientparams=18");
    this.URL_ANDROID_ACTION = "".concat(option.urlSchemePrefix, "action?action=");
    this.URL_TIP_PAGE = "".concat(option.ulinkPrefix, "/action?action="); // 注意：这里 action 前面有条杠

    this.URL_TIP_WEIBO_PAGE = "".concat(option.weiboUlinkPrefix || option.ulinkPrefix, "/action?action=");
    this.URL_YYB = option.yybLink;
    this.option = _objectSpread$1({}, option);
  } // -----------
  //  api
  // ----------


  createClass(AppInvoker, [{
    key: "getLizhiCommandCode",
    value: function getLizhiCommandCode(_ref5) {
      var _this3 = this;

      var id = _ref5.id,
          action = _ref5.action;
      var actionStr = encodeURIComponent(JSON.stringify(action));
      var fetchQuery = {
        // type: action.type,
        type: 50,
        content: actionStr // note：文档不清楚，可能会有 bug
        // content: action.type === 7 ? actionStr : action.id ? action.id : action.type

      }; // commandType: 口令类型，即 action 的 type
      // commandContent: action 的 字符串 ???
      // commandTipsType: app 是否出现弹窗 3-不出现

      var url = "".concat(this.option.tokenHost || TOKEN_HOST, "/get_command_code?commandType=").concat(fetchQuery.type, "&commandContent=").concat(fetchQuery.content, "&commandTipsType=3&requestId=").concat(Date.now());
      return this.fetchHelper(url).then(function (res) {
        if (res.rcode !== 0) {
          _this3.removeToken(id);

          return Promise.reject('server error');
        }

        var commandCode = res.data.commandCode;

        _this3.setToken(id, commandCode);

        return commandCode;
      });
    }
  }, {
    key: "getDahongpaoCommandCode",
    value: function getDahongpaoCommandCode(_ref6) {
      var _this4 = this;

      var id = _ref6.id,
          action = _ref6.action;
      var actionStr = JSON.stringify(action);
      return fetch$1("".concat(this.option.tokenHost, "/common/add_command"), {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        mode: 'cors',
        body: JSON.stringify({
          action: actionStr,
          rcmdRef: false,
          tipType: 3
        })
      }).then(function (res) {
        return res.json();
      }).then(function (res) {
        if (res.code !== 0) {
          _this4.removeAction(id);

          return Promise.reject('server error');
        }

        var commandCode = res.data.command;

        _this4.setToken(id, commandCode);

        return commandCode;
      });
    }
  }, {
    key: "dealToken",
    value: function () {
      var _dealToken = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(_ref7) {
        var id, action, el, ClipboardJS, actionStr;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = _ref7.id, action = _ref7.action, el = _ref7.el;

                if (id) {
                  _context.next = 3;
                  break;
                }

                throw new Error('id must be needed');

              case 3:
                _context.next = 5;
                return this.loadClipboard();

              case 5:
                ClipboardJS = _context.sent;
                new ClipboardJS(el);

                if (!this.hasToken(id)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", this.getToken(id));

              case 9:
                actionStr = encodeURIComponent(JSON.stringify(action));
                this.setAction(id, actionStr); // HOLDER to lock the same id fetch

                this.tokenMap[id] = 'HOLDER';

                if (!(this.option.appName === '大红袍')) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt("return", this.getDahongpaoCommandCode({
                  id: id,
                  action: action
                }));

              case 16:
                return _context.abrupt("return", this.getLizhiCommandCode({
                  id: id,
                  action: action
                }));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function dealToken(_x) {
        return _dealToken.apply(this, arguments);
      }

      return dealToken;
    }()
  }, {
    key: "getCommandCode",
    value: function getCommandCode(action, el) {
      var id = encodeURIComponent(JSON.stringify(action));
      return this.dealToken({
        id: id,
        action: action,
        el: el
      });
    }
    /**
     * 拷贝口令，并唤起app
     * 必需要用户手动事件触发
     * 目前支持ios9以上
     */

  }, {
    key: "evokeByToken",
    value: function evokeByToken(_ref8) {
      var id = _ref8.id,
          action = _ref8.action;
      if (!id) throw new Error('id must be needed');
      var token = this.getToken(id);
      var actionStr = this.getAction(id) || encodeURIComponent(JSON.stringify(action));

      if (!token) {
        this.evokeByActionAndToken({
          actionStr: actionStr
        });
        return;
      }

      this.evokeByActionAndToken({
        token: token,
        actionStr: actionStr
      }); // this.clipboard.writeText(token)
      //   .then(() => {
      //     console.log('clipboard success')
      //     this.evokeByActionAndToken({token, actionStr})
      //   }, (err) => {
      //     console.log(err)
      //     this.evokeByActionAndToken({actionStr})
      //   })
    }
  }, {
    key: "normalizeUrl",
    value: function normalizeUrl(_ref9) {
      var token = _ref9.token,
          actionStr = _ref9.actionStr,
          url = _ref9.url;

      var distinct_id = this.sensors && this.sensors.getPresetProperties()._distinct_id;

      url = url + actionStr;

      if (token) {
        url = url + "&t=".concat(token);
      }

      if (distinct_id) {
        url = url + "&distinct_id=".concat(distinct_id);
      }

      return url;
    }
  }, {
    key: "evokeByActionAndToken",
    value: function evokeByActionAndToken(_ref10) {
      var _this5 = this;

      var token = _ref10.token,
          actionStr = _ref10.actionStr;

      var distinct_id = this.sensors && this.sensors.getPresetProperties()._distinct_id;

      var normalizeUrl = function normalizeUrl(url) {
        return _this5.normalizeUrl({
          token: token,
          url: url,
          actionStr: actionStr
        });
      };

      var option = _objectSpread$1({}, this.option);

      var callApp = null;

      if (_typeof_1(option.callApp) === 'object') {
        // note: 特定平台的兼容性代码
        if (option.appName === '大红袍') {
          option.callApp = generateDahongPaoCallAppConfig(this.ua, option.callApp, {
            actionStr: actionStr,
            token: token,
            distinct_id: distinct_id
          });

          if (this.ua.weibo && (this.ua.iPad || this.ua.iPhone || this.ua.iPod)) {
            navigateWithAnchorClick(normalizeUrl(option.callApp.fallback));
            return;
          } // app 内，如荔枝播客的页面在APP内，直接使用ulink跳转


          if (this.ua.isApp) {
            window.location.href = normalizeUrl(this.URL_TIP_PAGE);
            return;
          }
        }

        try {
          callApp = new CallApp(option.callApp);
        } catch (e) {}
      }

      var openParam = {
        path: ''
      };

      if (actionStr || token) {
        var param = {};

        if (actionStr) {
          param.action = actionStr;
        }

        if (token) {
          param.t = token;
        }

        if (distinct_id) {
          param.distinct_id = distinct_id;
        }

        openParam = {
          path: option.actionPath || 'action',
          param: param
        };
      }

      var compatAction = function compatAction() {
        _this5.evoke({
          token: token,
          actionStr: actionStr
        });
      };

      if (callApp) {
        try {
          callApp.open(openParam);
        } catch (e) {
          compatAction();
        }
      } else {
        compatAction();
      }
    }
  }, {
    key: "evokeByAction",
    value: function () {
      var _evokeByAction = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(action) {
        var _this6 = this;

        var sensors;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getSensors();

              case 2:
                sensors = _context2.sent;
                this.sensors = sensors;
                setTimeout(function () {
                  var id = encodeURIComponent(JSON.stringify(action)); // try {
                  //   await this.dealToken({ id, action })
                  // } catch(e) {
                  //   console.error(e)
                  // }

                  _this6.evokeByToken({
                    id: id,
                    action: action
                  });
                }, 500);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function evokeByAction(_x2) {
        return _evokeByAction.apply(this, arguments);
      }

      return evokeByAction;
    }() // -----------
    //  内部方法
    // ----------

  }, {
    key: "loadClipboard",
    value: function loadClipboard() {
      var _this7 = this;

      if (this.clipboard) {
        return Promise.resolve(this.clipboard);
      } // 多次调用，不会多次下载


      return import(
      /* webpackChunkName: "thunk-clipboard" */
      'clipboard').then(function (_ref11) {
        var clipboard = _ref11["default"];
        _this7.clipboard = clipboard;
        return clipboard;
      });
    }
  }, {
    key: "setToken",
    value: function setToken(id, token) {
      if (!id) throw new Error('id must be needed');
      this.tokenMap[id] = token;
      this.tokenMap['size'] = typeof this.tokenMap['size'] === 'undefined' ? 1 : Number(this.tokenMap['size']) + 1;
    }
  }, {
    key: "getToken",
    value: function getToken(id) {
      if (!id) throw new Error('id must be needed');
      return this.tokenMap[id] ? this.tokenMap[id] === 'HOLDER' ? '' : this.tokenMap[id] : '';
    }
  }, {
    key: "removeToken",
    value: function removeToken(id) {
      if (!id) throw new Error('id must be needed');
      delete this.tokenMap[id];
    }
  }, {
    key: "hasToken",
    value: function hasToken(id) {
      if (!id) throw new Error('id must be needed');
      return this.tokenMap[id] != null;
    }
  }, {
    key: "tokenSize",
    value: function tokenSize() {
      return typeof this.tokenMap.size === 'undefined' ? 0 : this.tokenMap.size;
    }
  }, {
    key: "setAction",
    value: function setAction(id, actionStr) {
      if (!id) throw new Error('id must be needed');
      this.actionMap[id] = actionStr;
    }
  }, {
    key: "getAction",
    value: function getAction(id) {
      return this.actionMap[id];
    }
  }, {
    key: "removeAction",
    value: function removeAction(id) {
      if (!id) throw new Error('id must be needed');
      delete this.actionMap[id];
    } // ios browser: safari chrome uc qq quark
    // ios webview: wechat qq weibo weibo-internet
    // android browser: chrome qq liebao firfox 自带 vivo xiaomi meizu huawei
    // android webview: wechat qq weibo

  }, {
    key: "evoke",
    value: function evoke(_ref12) {
      var _this8 = this;

      var token = _ref12.token,
          actionStr = _ref12.actionStr;

      var normalizeUrl = function normalizeUrl(url) {
        return _this8.normalizeUrl({
          token: token,
          url: url,
          actionStr: actionStr
        });
      };

      var fallback = function fallback() {
        setTimeout(function () {
          if (document.hidden === false || document.visibilityState === 'visible') {
            actionStr ? window.location.href = normalizeUrl(_this8.URL_TIP_PAGE) : window.location.href = _this8.URL_ULINK;
          }
        }, 1000);
      }; // 微博 webview


      if (this.ua.weibo) {
        // window.location.href = normalizeUrl(this.URL_TIP_WEIBO_PAGE)
        navigateWithAnchorClick(normalizeUrl(this.URL_TIP_WEIBO_PAGE));
        fallback();
        return;
      } // 微信与QQ webview


      if (this.ua.wx || this.ua.qq) {
        // ios/android： 跳去引导页
        // 安卓使用应用宝
        if (this.ua.android) {
          window.location.href = this.URL_YYB;
          return;
        }

        window.location.href = normalizeUrl(this.URL_TIP_PAGE);
        return;
      }

      if (this.ua.quarkBrowser) {
        // ios/android： yyb
        // window.location.href = this.URL_YYB
        if (this.ua.android) {
          window.location.href = normalizeUrl(this.URL_ANDROID_ACTION);
          fallback();
        } else {
          window.location.href = normalizeUrl(this.URL_TIP_PAGE);
        }

        return;
      } else {
        if (this.ua.iPhone || this.ua.iPad) {
          // ios qq浏览器： 不支持ulink 支持shema
          if (this.ua.qqBrowser) {
            navigateWithAnchorClick(actionStr ? normalizeUrl(this.URL_IOS_ACTION) : this.URL_SCHEMA);
            fallback();
            return;
          } // 其他：全部用ulink，支持度很好


          actionStr ? window.location.href = normalizeUrl(this.URL_TIP_PAGE) : window.location.href = this.URL_ULINK;
        } else if (this.ua.android) {
          // 微博：唤起手机浏览器
          if (this.ua.weibo) {
            navigateWithAnchorClick(normalizeUrl(this.URL_TIP_PAGE));
            return;
          } // 其他：schema


          actionStr ? window.location.href = normalizeUrl(this.URL_ANDROID_ACTION) : window.location.href = this.URL_SCHEMA; // 1s钟后跳转到ulink页

          fallback();
        } else {
          // 非ios android：跳去引导页
          actionStr ? window.location.href = normalizeUrl(this.URL_TIP_PAGE) : window.location.href = this.URL_TIP_PAGE;
        }
      }
    }
  }, {
    key: "fetchHelper",
    value: function fetchHelper(url) {
      return new Promise(function (resolve, reject) {
        if (window.fetch) {
          window.fetch(url, {
            credentials: 'include',
            mode: 'cors'
          }).then(function (res) {
            return res.json();
          }).then(function (res) {
            return resolve(res);
          })["catch"](function (err) {
            return reject(err);
          });
        } else {
          var xhr = new XMLHttpRequest();
          xhr.open('get', url, true);
          xhr.withCredentials = true;
          xhr.responseType = 'json';

          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
              return resolve(xhr.response);
            }

            return reject('server error');
          };

          xhr.send();
        }
      });
    }
  }]);

  return AppInvoker;
}();

function navigateWithAnchorClick(url) {
  var a = document.createElement('a');
  a.href = url;
  a.setAttribute('download', 'lizhi');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
} // 大红袍app吊起配置的特殊逻辑


function generateDahongPaoCallAppConfig(ua, originOpt, params) {
  var actionStr = params.actionStr,
      token = params.token,
      distinct_id = params.distinct_id;

  var config = _objectSpread$1(_objectSpread$1({}, originOpt), {}, {
    scheme: {
      protocol: ua.android ? "dahongpao" : 'dhp66626'
    },
    intent: {
      "package": 'com.lizhi.podcast',
      scheme: 'dahongpao'
    },
    appstore: ua.weibo ? 'https://itunes.apple.com/app/apple-store/id1536375624?c=https://itunes.apple.com/us/app/weibo/id350962117' : originOpt.appstore
  });

  if (ua.weibo) {
    config.fallback = 'https://dahongpaolink.lizhifm.com/ulink/';
    config.universal.host = 'dahongpaolink.lizhifm.com/ulink/action?';
  }

  var seperator = config.fallback.indexOf('?') > -1 ? '&' : '?';

  if (actionStr) {
    config.fallback = "".concat(config.fallback).concat(seperator, "action=").concat(actionStr);
    seperator = '&';
  }

  if (token) {
    config.fallback = "".concat(config.fallback).concat(seperator, "t=").concat(token);
  }

  if (distinct_id) {
    config.fallback = "".concat(config.fallback).concat(seperator, "distinct_id=").concat(distinct_id);
  }

  return config;
}

function getAppInvoker(config) {
  return new AppInvoker(config);
}

var cache = {};

function useInterceptor(interceptors) {
  var proxy = {};

  var _loop = function _loop() {
    var _Object$entries$_i = slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        _Object$entries$_i$ = _Object$entries$_i[1],
        val = _Object$entries$_i$.val,
        description = _Object$entries$_i$.description;

    var getter = description.get;
    addImmutableProp(proxy, key, val, _objectSpread$1(_objectSpread$1({}, description), {}, {
      get: function get() {
        var interceptor = interceptors[key];

        if (getter) {
          val = getter.call(this);
        }

        if (typeof interceptor !== 'undefined') {
          val = interceptor;
        }

        if (typeof val === 'function') {
          return val.bind(proxy);
        }

        return val;
      }
    }));
  };

  for (var _i = 0, _Object$entries = Object.entries(cache); _i < _Object$entries.length; _i++) {
    _loop();
  }

  return proxy;
}

function addInterceptorProp(proxy, key, val) {
  var description = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  cache[key] = {
    val: val,
    description: description
  };
  return addImmutableProp(proxy, key, val, description);
}

function interceptorRegister(proxy) {
  addImmutableProp(proxy, 'useInterceptor', useInterceptor);
}

var SERVER_ENV = process.env.SERVER_ENV || window.SERVER_ENV;
var COMPONENT_ENV = process.env.COMPONENT_ENV || window.COMPONENT_ENV;
var shouldConfig = isHttps && (SERVER_ENV === 'production' || SERVER_ENV === 'pre');
var isInsideApp = lz.isApp;
var isUnderMockingEnv = COMPONENT_ENV === 'editing' || COMPONENT_ENV === 'development';
var staticList = ['isApp', 'isReady'];
var configParams = {
  apiList: [],
  eventList: []
};
var url; // 因为客户端的 ua 设置问题，荔枝之外的 app 的判断请放在判断 lizhifm 的 if else 的判断之前。

if (/zhiya/ig.test(ua)) {
  url = configUrl$1;
  configParams.apiList = apiList$1;
  configParams.eventList = eventList$1;
} else if (/tiya/ig.test(ua)) {
  url = configUrl$2;
  configParams.apiList = apiList$1;
  configParams.eventList = eventList$1;
} else if (/pongpong/ig.test(ua)) {
  url = configUrl$3;
  configParams.apiList = apiList;
  configParams.eventList = eventList;
} else if (/pplive/ig.test(ua)) {
  url = configUrl$4;
  configParams.apiList = apiList;
  configParams.eventList = eventList; // 如果需要新增其他客户端的判断，请加载下方的 if else 之前。
} else if (/dahongpao/ig.test(ua)) {
  url = configUrl$5;
  configParams.apiList = apiList;
  configParams.eventList = eventList;
} else if (/lizhifm/ig.test(ua)) {
  url = configUrl;
  configParams.apiList = apiList;
  configParams.eventList = eventList;
} else {
  configParams.apiList = apiList;
  configParams.eventList = eventList;
}

var handlerMap = {};
var proxy = {};
interceptorRegister(proxy);
staticList.forEach(function (key) {
  return addInterceptorProp(proxy, key, lz[key], {
    get: function get() {
      return lz[key];
    }
  });
});
var readyHandlerList = [];
lz.ready(function () {
  readyHandlerList.forEach(function (fn) {
    fn();
  });
});

function lzReady(fn) {
  if (typeof fn !== 'function') {
    return;
  }

  if (lz.isReady) {
    return fn();
  }

  readyHandlerList.push(fn);
}

configParams.apiList.forEach(function (apiName) {
  if (apiName === 'config' || apiName === 'ready') {
    addInterceptorProp(proxy, apiName, noop);
    return;
  }

  if (apiName === 'getWebDisplayInfo' && isUnderMockingEnv) {
    addInterceptorProp(proxy, apiName, mockGetWebDisplayInfo);
    return;
  } // toAction


  if (apiName === 'toAction') {
    addInterceptorProp(proxy, apiName, invokeActionOutsideApp);
    return;
  }

  if (isInsideApp === false) {
    addInterceptorProp(proxy, apiName, invokeOutsideApp);
    return;
  }

  addInterceptorProp(proxy, apiName, proxyMethod(apiName));
});
addInterceptorProp(proxy, 'on', function () {
  var argv = Array.prototype.slice.call(arguments);

  var _argv = slicedToArray(argv, 2),
      eventType = _argv[0],
      handler = _argv[1];

  if (isUnderMockingEnv) {
    handlerMap[eventType] = (handlerMap[eventType] || []).concat([handler]);
  }

  return lz.on.apply(lz, argv);
});
addInterceptorProp(proxy, 'ready', lzReady);
addInterceptorProp(proxy, 'isInsideApp', isInsideApp, {
  enumerable: false
});
addInterceptorProp(proxy, '__handlerMap__', handlerMap, {
  enumerable: false
});

if (isUnderMockingEnv) {
  addInterceptorProp(proxy, '__triggerEvent__', function (eventType, data) {
    var handlerList = handlerMap[eventType] || [];

    for (var i = 0; i < handlerList.length; i++) {
      try {
        handlerList[i](data);
      } catch (e) {
        console.error(e);
      }
    }
  });
}

if (isInsideApp) {
  if (shouldConfig) {
    configParams.url = url;
  }

  lz.config(configParams);
}

var appConfig = null;
var appInvoker = null;

function initLz(_x3) {
  return _initLz.apply(this, arguments);
}

function _initLz() {
  _initLz = asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(config) {
    return regenerator.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            appConfig = _objectSpread$1({}, config);
            console.log('appConfig', appConfig);
            appInvoker = getAppInvoker(appConfig);
            _context5.next = 5;
            return initSensors();

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _initLz.apply(this, arguments);
}

function noop() {}

function proxyMethod(apiName) {
  return function () {
    var argv = Array.prototype.slice.call(arguments);
    var cb = argv[1];

    if (typeof cb !== 'function') {
      return new Promise(function (resolve) {
        lzReady(function () {
          var promise = lz[apiName].apply(lz, argv);
          promise.then(function (ret) {
            resolve(ret);
          });
        });
      });
    }

    lzReady(function () {
      lz[apiName].apply(lz, argv);
    });
  };
}

function invokeActionOutsideApp() {
  var isNotConfigApp = appConfig && appConfig.ua && !navigator.userAgent.toLowerCase().includes(appConfig.ua);

  if (isInsideApp === false || isNotConfigApp) {
    var argv = Array.prototype.slice.call(arguments); // 当回调方法后面再跟一个对象时，我们约定这个对象是一个 action 对象
    // 会自动解析这个对象，并尝试吊起 ulink 或者 url scheme

    var cb = argv[1];
    var action = argv[argv.length - 1];
    var isCbFunction = typeof cb === 'function';

    if (action) {
      if (COMPONENT_ENV === 'editing') {
        console.info('调用了 action 跳转：', action);
        return;
      }

      if (appConfig) {
        appInvoker.evokeByAction(action);
        return;
      }
    }

    var reason = {
      status: 'failed',
      isInsideApp: isInsideApp
    };

    if (isCbFunction) {
      return cb(reason);
    }

    return Promise.reject(reason);
  } else {
    return proxyMethod('toAction').apply(null, arguments);
  }
}

function invokeOutsideApp() {
  var argv = Array.prototype.slice.call(arguments); // 当回调方法后面再跟一个对象时，我们约定这个对象是一个 action 对象
  // 会自动解析这个对象，并尝试吊起 ulink 或者 url scheme

  var cb = argv[1];
  var isCbFunction = typeof cb === 'function';
  var reason = {
    status: 'failed',
    isInsideApp: isInsideApp
  };

  if (isCbFunction) {
    return cb(reason);
  }

  return Promise.reject(reason);
}

function mockGetWebDisplayInfo(opt, cb) {
  var len = Math.round(Math.random() * 10);
  var index = Math.round(len / 2);
  var displayInfo = [];

  for (var i = 0; i < len; i++) {
    displayInfo.push({
      x: 0,
      y: Math.round(Math.random() * 1000 / 2),
      w: Math.round(Math.random() * 100),
      h: Math.round(Math.random() * 100)
    });
  }

  var ret = {
    emptyFrame: displayInfo[index],
    status: 'success'
  };

  if (cb == null) {
    return Promise.resolve(ret);
  }

  cb(ret);
}

var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */

var INFINITY$1 = 1 / 0;
/** `Object#toString` result references. */

var symbolTag$1 = '[object Symbol]';
/** Used to match words composed of alphanumeric characters. */

var reAsciiWord$1 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/** Used to match Latin Unicode letters (excluding mathematical operators). */

var reLatin$1 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */

var rsAstralRange$1 = "\\ud800-\\udfff",
    rsComboMarksRange$1 = "\\u0300-\\u036f\\ufe20-\\ufe23",
    rsComboSymbolsRange$1 = "\\u20d0-\\u20f0",
    rsDingbatRange$1 = "\\u2700-\\u27bf",
    rsLowerRange$1 = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange$1 = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange$1 = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange$1 = "\\u2000-\\u206f",
    rsSpaceRange$1 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
    rsUpperRange$1 = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange$1 = "\\ufe0e\\ufe0f",
    rsBreakRange$1 = rsMathOpRange$1 + rsNonCharRange$1 + rsPunctuationRange$1 + rsSpaceRange$1;
/** Used to compose unicode capture groups. */

var rsApos$1 = "['\u2019]",
    rsAstral = '[' + rsAstralRange$1 + ']',
    rsBreak$1 = '[' + rsBreakRange$1 + ']',
    rsCombo$1 = '[' + rsComboMarksRange$1 + rsComboSymbolsRange$1 + ']',
    rsDigits$1 = '\\d+',
    rsDingbat$1 = '[' + rsDingbatRange$1 + ']',
    rsLower$1 = '[' + rsLowerRange$1 + ']',
    rsMisc$1 = '[^' + rsAstralRange$1 + rsBreakRange$1 + rsDigits$1 + rsDingbatRange$1 + rsLowerRange$1 + rsUpperRange$1 + ']',
    rsFitz$1 = "\\ud83c[\\udffb-\\udfff]",
    rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$1 + ']',
    rsRegional$1 = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    rsSurrPair$1 = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    rsUpper$1 = '[' + rsUpperRange$1 + ']',
    rsZWJ$1 = "\\u200d";
/** Used to compose unicode regexes. */

var rsLowerMisc$1 = '(?:' + rsLower$1 + '|' + rsMisc$1 + ')',
    rsUpperMisc$1 = '(?:' + rsUpper$1 + '|' + rsMisc$1 + ')',
    rsOptLowerContr$1 = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr$1 = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$1 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsEmoji$1 = '(?:' + [rsDingbat$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1,
    rsSymbol = '(?:' + [rsNonAstral$1 + rsCombo$1 + '?', rsCombo$1, rsRegional$1, rsSurrPair$1, rsAstral].join('|') + ')';
/** Used to match apostrophes. */

var reApos$1 = RegExp(rsApos$1, 'g');
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */

var reComboMark$1 = RegExp(rsCombo$1, 'g');
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */

var reUnicode = RegExp(rsFitz$1 + '(?=' + rsFitz$1 + ')|' + rsSymbol + rsSeq$1, 'g');
/** Used to match complex or compound words. */

var reUnicodeWord$1 = RegExp([rsUpper$1 + '?' + rsLower$1 + '+' + rsOptLowerContr$1 + '(?=' + [rsBreak$1, rsUpper$1, '$'].join('|') + ')', rsUpperMisc$1 + '+' + rsOptUpperContr$1 + '(?=' + [rsBreak$1, rsUpper$1 + rsLowerMisc$1, '$'].join('|') + ')', rsUpper$1 + '?' + rsLowerMisc$1 + '+' + rsOptLowerContr$1, rsUpper$1 + '+' + rsOptUpperContr$1, rsDigits$1, rsEmoji$1].join('|'), 'g');
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */

var reHasUnicode = RegExp('[' + rsZWJ$1 + rsAstralRange$1 + rsComboMarksRange$1 + rsComboSymbolsRange$1 + rsVarRange$1 + ']');
/** Used to detect strings that need a more robust regexp to match words. */

var reHasUnicodeWord$1 = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/** Used to map Latin Unicode letters to basic Latin letters. */

var deburredLetters$1 = {
  // Latin-1 Supplement block.
  '\xc0': 'A',
  '\xc1': 'A',
  '\xc2': 'A',
  '\xc3': 'A',
  '\xc4': 'A',
  '\xc5': 'A',
  '\xe0': 'a',
  '\xe1': 'a',
  '\xe2': 'a',
  '\xe3': 'a',
  '\xe4': 'a',
  '\xe5': 'a',
  '\xc7': 'C',
  '\xe7': 'c',
  '\xd0': 'D',
  '\xf0': 'd',
  '\xc8': 'E',
  '\xc9': 'E',
  '\xca': 'E',
  '\xcb': 'E',
  '\xe8': 'e',
  '\xe9': 'e',
  '\xea': 'e',
  '\xeb': 'e',
  '\xcc': 'I',
  '\xcd': 'I',
  '\xce': 'I',
  '\xcf': 'I',
  '\xec': 'i',
  '\xed': 'i',
  '\xee': 'i',
  '\xef': 'i',
  '\xd1': 'N',
  '\xf1': 'n',
  '\xd2': 'O',
  '\xd3': 'O',
  '\xd4': 'O',
  '\xd5': 'O',
  '\xd6': 'O',
  '\xd8': 'O',
  '\xf2': 'o',
  '\xf3': 'o',
  '\xf4': 'o',
  '\xf5': 'o',
  '\xf6': 'o',
  '\xf8': 'o',
  '\xd9': 'U',
  '\xda': 'U',
  '\xdb': 'U',
  '\xdc': 'U',
  '\xf9': 'u',
  '\xfa': 'u',
  '\xfb': 'u',
  '\xfc': 'u',
  '\xdd': 'Y',
  '\xfd': 'y',
  '\xff': 'y',
  '\xc6': 'Ae',
  '\xe6': 'ae',
  '\xde': 'Th',
  '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  "\u0100": 'A',
  "\u0102": 'A',
  "\u0104": 'A',
  "\u0101": 'a',
  "\u0103": 'a',
  "\u0105": 'a',
  "\u0106": 'C',
  "\u0108": 'C',
  "\u010A": 'C',
  "\u010C": 'C',
  "\u0107": 'c',
  "\u0109": 'c',
  "\u010B": 'c',
  "\u010D": 'c',
  "\u010E": 'D',
  "\u0110": 'D',
  "\u010F": 'd',
  "\u0111": 'd',
  "\u0112": 'E',
  "\u0114": 'E',
  "\u0116": 'E',
  "\u0118": 'E',
  "\u011A": 'E',
  "\u0113": 'e',
  "\u0115": 'e',
  "\u0117": 'e',
  "\u0119": 'e',
  "\u011B": 'e',
  "\u011C": 'G',
  "\u011E": 'G',
  "\u0120": 'G',
  "\u0122": 'G',
  "\u011D": 'g',
  "\u011F": 'g',
  "\u0121": 'g',
  "\u0123": 'g',
  "\u0124": 'H',
  "\u0126": 'H',
  "\u0125": 'h',
  "\u0127": 'h',
  "\u0128": 'I',
  "\u012A": 'I',
  "\u012C": 'I',
  "\u012E": 'I',
  "\u0130": 'I',
  "\u0129": 'i',
  "\u012B": 'i',
  "\u012D": 'i',
  "\u012F": 'i',
  "\u0131": 'i',
  "\u0134": 'J',
  "\u0135": 'j',
  "\u0136": 'K',
  "\u0137": 'k',
  "\u0138": 'k',
  "\u0139": 'L',
  "\u013B": 'L',
  "\u013D": 'L',
  "\u013F": 'L',
  "\u0141": 'L',
  "\u013A": 'l',
  "\u013C": 'l',
  "\u013E": 'l',
  "\u0140": 'l',
  "\u0142": 'l',
  "\u0143": 'N',
  "\u0145": 'N',
  "\u0147": 'N',
  "\u014A": 'N',
  "\u0144": 'n',
  "\u0146": 'n',
  "\u0148": 'n',
  "\u014B": 'n',
  "\u014C": 'O',
  "\u014E": 'O',
  "\u0150": 'O',
  "\u014D": 'o',
  "\u014F": 'o',
  "\u0151": 'o',
  "\u0154": 'R',
  "\u0156": 'R',
  "\u0158": 'R',
  "\u0155": 'r',
  "\u0157": 'r',
  "\u0159": 'r',
  "\u015A": 'S',
  "\u015C": 'S',
  "\u015E": 'S',
  "\u0160": 'S',
  "\u015B": 's',
  "\u015D": 's',
  "\u015F": 's',
  "\u0161": 's',
  "\u0162": 'T',
  "\u0164": 'T',
  "\u0166": 'T',
  "\u0163": 't',
  "\u0165": 't',
  "\u0167": 't',
  "\u0168": 'U',
  "\u016A": 'U',
  "\u016C": 'U',
  "\u016E": 'U',
  "\u0170": 'U',
  "\u0172": 'U',
  "\u0169": 'u',
  "\u016B": 'u',
  "\u016D": 'u',
  "\u016F": 'u',
  "\u0171": 'u',
  "\u0173": 'u',
  "\u0174": 'W',
  "\u0175": 'w',
  "\u0176": 'Y',
  "\u0177": 'y',
  "\u0178": 'Y',
  "\u0179": 'Z',
  "\u017B": 'Z',
  "\u017D": 'Z',
  "\u017A": 'z',
  "\u017C": 'z',
  "\u017E": 'z',
  "\u0132": 'IJ',
  "\u0133": 'ij',
  "\u0152": 'Oe',
  "\u0153": 'oe',
  "\u0149": "'n",
  "\u017F": 'ss'
};
/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = _typeof_1(commonjsGlobal$1) == 'object' && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;
/** Detect free variable `self`. */

var freeSelf$1 = (typeof self === "undefined" ? "undefined" : _typeof_1(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */

function arrayReduce$1(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }

  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }

  return accumulator;
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */


function asciiToArray(string) {
  return string.split('');
}
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */


function asciiWords$1(string) {
  return string.match(reAsciiWord$1) || [];
}
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */


function basePropertyOf$1(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */


var deburrLetter$1 = basePropertyOf$1(deburredLetters$1);
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */

function hasUnicode(string) {
  return reHasUnicode.test(string);
}
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */


function hasUnicodeWord$1(string) {
  return reHasUnicodeWord$1.test(string);
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */


function stringToArray(string) {
  return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */


function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */


function unicodeWords$1(string) {
  return string.match(reUnicodeWord$1) || [];
}
/** Used for built-in method references. */


var objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString$1 = objectProto$1.toString;
/** Built-in value references. */

var Symbol$1 = root$1.Symbol;
/** Used to convert symbols to primitives and strings. */

var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : undefined;
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }

  end = end > length ? length : end;

  if (end < 0) {
    end += length;
  }

  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);

  while (++index < length) {
    result[index] = array[index + start];
  }

  return result;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */


function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isSymbol$1(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */


function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return !start && end >= length ? array : baseSlice(array, start, end);
}
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */


function createCaseFirst(methodName) {
  return function (string) {
    string = toString$1(string);
    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
    var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
    return chr[methodName]() + trailing;
  };
}
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */


function createCompounder$1(callback) {
  return function (string) {
    return arrayReduce$1(words$1(deburr$1(string).replace(reApos$1, '')), callback, '');
  };
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike$1(value) {
  return !!value && _typeof_1(value) == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */


function isSymbol$1(value) {
  return _typeof_1(value) == 'symbol' || isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */


function toString$1(value) {
  return value == null ? '' : baseToString$1(value);
}
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */


var camelCase = createCompounder$1(function (result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */

function capitalize(string) {
  return upperFirst(toString$1(string).toLowerCase());
}
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */


function deburr$1(string) {
  string = toString$1(string);
  return string && string.replace(reLatin$1, deburrLetter$1).replace(reComboMark$1, '');
}
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */


var upperFirst = createCaseFirst('toUpperCase');
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */

function words$1(string, pattern, guard) {
  string = toString$1(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord$1(string) ? unicodeWords$1(string) : asciiWords$1(string);
  }

  return string.match(pattern) || [];
}

var lodash_camelcase = camelCase;

function composeComponentName(namespace, compName) {
  var prefix = namespace;

  if (_typeof_1(namespace) === 'object') {
    prefix = namespace.join(' ');
  }

  return lodash_camelcase(prefix + ' ' + compName);
}

function getEditorField(name) {
  return name === 'styles' ? 'styles' : "propsData.static.".concat(name);
}

function verifyTag(tag, tagPreset) {
  var TAG_ILLEGAL = false;

  if (tag == null) {
    TAG_ILLEGAL = true;
  }

  if (typeof tag === 'string' && tag.length > 0) {
    if (tagPreset[tag] == null) {
      TAG_ILLEGAL = true;
    }
  }

  if (_typeof_1(tag) === 'object' && tag.length > 0) {
    var isIncluded = tag.every(function (item) {
      return tagPreset[item] != null;
    });
    TAG_ILLEGAL = !isIncluded;
  }

  if (TAG_ILLEGAL) {
    throw new Error('只使用 TAG_PRESET 里面的标签');
  }

  return true;
}

function registerFactory(TAG_PRESET) {
  var ABANDONED_TAG = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return /*#__PURE__*/function () {
    function Register(_ref13) {
      var tag = _ref13.tag,
          usage = _ref13.usage,
          componentName = _ref13.componentName;

      classCallCheck(this, Register);

      if (tag == null || tag.length === 0) {
        throw new Error('请传入至少一个标签');
      }

      if (typeof tag === 'string') {
        if (ABANDONED_TAG[tag]) {
          console.warn("groot-sdk: TAG_PRESET.".concat(tag.toUpperCase(), " \u5DF2\u7ECF\u88AB\u629B\u5F03\uFF0C\u81EA\u52A8\u5728 VOD, LIVE, ZY \u4EE5\u5916\u7684\u90FD\u4F1A\u81EA\u52A8\u5F52\u4E3A COMMON\u3002"));
          tag = [TAG_PRESET.COMMON];
        } else {
          tag = [tag];
        }
      } else {
        tag = tag.map(function (t) {
          if (ABANDONED_TAG[t]) {
            return TAG_PRESET.COMMON;
          }

          return t;
        });
        tag = tag.slice(0, 1);
      }

      if (verifyTag(tag, TAG_PRESET)) {
        this.tag = tag;
      }

      this.usage = usage;

      if (componentName) {
        this.componentName = componentName;
      }
    }

    createClass(Register, [{
      key: "createModule",
      value: function createModule(component) {
        throw new Error('请检查该方法有没有实现！！！');
      }
    }]);

    return Register;
  }();
}

function verifyEventData(eventData) {
  if (eventData.eventId == null) {
    console.warn('打点失败：' + '缺少 eventId 属性！');
    return false;
  }

  return true;
}

function pushBaiduEvent(eventData) {
  var eventId = eventData.eventId,
      _eventData$data = eventData.data,
      data = _eventData$data === void 0 ? {} : _eventData$data;
  var params = ['_trackEvent', eventId];

  for (var key in data) {
    if (key === 'action') {
      params.splice(2, 0, data[key]);
    } else {
      params.push(key);
      params.push(data[key]);
    }
  }

  console.log(params);

  if (window._hmt) {
    window._hmt.pushEvent(params);
  }
}

function reportEvent(eventData) {
  if (verifyEventData(eventData) === false) {
    return;
  }

  pushBaiduEvent(eventData);
  webReport(eventData);
}

var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
  RFC1738: 'RFC1738',
  RFC3986: 'RFC3986'
};
var formats = {
  'default': Format.RFC3986,
  formatters: {
    RFC1738: function RFC1738(value) {
      return replace.call(value, percentTwenties, '+');
    },
    RFC3986: function RFC3986(value) {
      return String(value);
    }
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986
};
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = function () {
  var array = [];

  for (var i = 0; i < 256; ++i) {
    array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
  }

  return array;
}();

var compactQueue = function compactQueue(queue) {
  while (queue.length > 1) {
    var item = queue.pop();
    var obj = item.obj[item.prop];

    if (isArray(obj)) {
      var compacted = [];

      for (var j = 0; j < obj.length; ++j) {
        if (typeof obj[j] !== 'undefined') {
          compacted.push(obj[j]);
        }
      }

      item.obj[item.prop] = compacted;
    }
  }
};

var arrayToObject = function arrayToObject(source, options) {
  var obj = options && options.plainObjects ? Object.create(null) : {};

  for (var i = 0; i < source.length; ++i) {
    if (typeof source[i] !== 'undefined') {
      obj[i] = source[i];
    }
  }

  return obj;
};

var merge = function merge(target, source, options) {
  /* eslint no-param-reassign: 0 */
  if (!source) {
    return target;
  }

  if (_typeof_1(source) !== 'object') {
    if (isArray(target)) {
      target.push(source);
    } else if (target && _typeof_1(target) === 'object') {
      if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) {
        target[source] = true;
      }
    } else {
      return [target, source];
    }

    return target;
  }

  if (!target || _typeof_1(target) !== 'object') {
    return [target].concat(source);
  }

  var mergeTarget = target;

  if (isArray(target) && !isArray(source)) {
    mergeTarget = arrayToObject(target, options);
  }

  if (isArray(target) && isArray(source)) {
    source.forEach(function (item, i) {
      if (has.call(target, i)) {
        var targetItem = target[i];

        if (targetItem && _typeof_1(targetItem) === 'object' && item && _typeof_1(item) === 'object') {
          target[i] = merge(targetItem, item, options);
        } else {
          target.push(item);
        }
      } else {
        target[i] = item;
      }
    });
    return target;
  }

  return Object.keys(source).reduce(function (acc, key) {
    var value = source[key];

    if (has.call(acc, key)) {
      acc[key] = merge(acc[key], value, options);
    } else {
      acc[key] = value;
    }

    return acc;
  }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
  return Object.keys(source).reduce(function (acc, key) {
    acc[key] = source[key];
    return acc;
  }, target);
};

var decode = function decode(str, decoder, charset) {
  var strWithoutPlus = str.replace(/\+/g, ' ');

  if (charset === 'iso-8859-1') {
    // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  } // utf-8


  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e) {
    return strWithoutPlus;
  }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
  // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
  // It has been adapted here for stricter adherence to RFC 3986
  if (str.length === 0) {
    return str;
  }

  var string = str;

  if (_typeof_1(str) === 'symbol') {
    string = Symbol.prototype.toString.call(str);
  } else if (typeof str !== 'string') {
    string = String(str);
  }

  if (charset === 'iso-8859-1') {
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
      return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
  }

  var out = '';

  for (var i = 0; i < string.length; ++i) {
    var c = string.charCodeAt(i);

    if (c === 0x2D // -
    || c === 0x2E // .
    || c === 0x5F // _
    || c === 0x7E // ~
    || c >= 0x30 && c <= 0x39 // 0-9
    || c >= 0x41 && c <= 0x5A // a-z
    || c >= 0x61 && c <= 0x7A // A-Z
    || format === formats.RFC1738 && (c === 0x28 || c === 0x29) // ( )
    ) {
        out += string.charAt(i);
        continue;
      }

    if (c < 0x80) {
      out = out + hexTable[c];
      continue;
    }

    if (c < 0x800) {
      out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
      continue;
    }

    if (c < 0xD800 || c >= 0xE000) {
      out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
      continue;
    }

    i += 1;
    c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
    out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
  }

  return out;
};

var compact = function compact(value) {
  var queue = [{
    obj: {
      o: value
    },
    prop: 'o'
  }];
  var refs = [];

  for (var i = 0; i < queue.length; ++i) {
    var item = queue[i];
    var obj = item.obj[item.prop];
    var keys = Object.keys(obj);

    for (var j = 0; j < keys.length; ++j) {
      var key = keys[j];
      var val = obj[key];

      if (_typeof_1(val) === 'object' && val !== null && refs.indexOf(val) === -1) {
        queue.push({
          obj: obj,
          prop: key
        });
        refs.push(val);
      }
    }
  }

  compactQueue(queue);
  return value;
};

var isRegExp = function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
  if (!obj || _typeof_1(obj) !== 'object') {
    return false;
  }

  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
  return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
  if (isArray(val)) {
    var mapped = [];

    for (var i = 0; i < val.length; i += 1) {
      mapped.push(fn(val[i]));
    }

    return mapped;
  }

  return fn(val);
};

var utils = {
  arrayToObject: arrayToObject,
  assign: assign,
  combine: combine,
  compact: compact,
  decode: decode,
  encode: encode,
  isBuffer: isBuffer,
  isRegExp: isRegExp,
  maybeMap: maybeMap,
  merge: merge
};
var has$1 = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
  brackets: function brackets(prefix) {
    return prefix + '[]';
  },
  comma: 'comma',
  indices: function indices(prefix, key) {
    return prefix + '[' + key + ']';
  },
  repeat: function repeat(prefix) {
    return prefix;
  }
};
var isArray$1 = Array.isArray;
var push = Array.prototype.push;

var pushToArray = function pushToArray(arr, valueOrArray) {
  push.apply(arr, isArray$1(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;
var defaultFormat = formats['default'];
var defaults = {
  addQueryPrefix: false,
  allowDots: false,
  charset: 'utf-8',
  charsetSentinel: false,
  delimiter: '&',
  encode: true,
  encoder: utils.encode,
  encodeValuesOnly: false,
  format: defaultFormat,
  formatter: formats.formatters[defaultFormat],
  // deprecated
  indices: false,
  serializeDate: function serializeDate(date) {
    return toISO.call(date);
  },
  skipNulls: false,
  strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
  return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || _typeof_1(v) === 'symbol' || typeof v === 'bigint';
};

var stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset) {
  var obj = object;

  if (typeof filter === 'function') {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = serializeDate(obj);
  } else if (generateArrayPrefix === 'comma' && isArray$1(obj)) {
    obj = utils.maybeMap(obj, function (value) {
      if (value instanceof Date) {
        return serializeDate(value);
      }

      return value;
    });
  }

  if (obj === null) {
    if (strictNullHandling) {
      return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
    }

    obj = '';
  }

  if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
    if (encoder) {
      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
      return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
    }

    return [formatter(prefix) + '=' + formatter(String(obj))];
  }

  var values = [];

  if (typeof obj === 'undefined') {
    return values;
  }

  var objKeys;

  if (generateArrayPrefix === 'comma' && isArray$1(obj)) {
    // we need to join elements in
    objKeys = [{
      value: obj.length > 0 ? obj.join(',') || null : undefined
    }];
  } else if (isArray$1(filter)) {
    objKeys = filter;
  } else {
    var keys = Object.keys(obj);
    objKeys = sort ? keys.sort(sort) : keys;
  }

  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];
    var value = _typeof_1(key) === 'object' && key.value !== undefined ? key.value : obj[key];

    if (skipNulls && value === null) {
      continue;
    }

    var keyPrefix = isArray$1(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? '.' + key : '[' + key + ']');
    pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset));
  }

  return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
  if (!opts) {
    return defaults;
  }

  if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
    throw new TypeError('Encoder has to be a function.');
  }

  var charset = opts.charset || defaults.charset;

  if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
  }

  var format = formats['default'];

  if (typeof opts.format !== 'undefined') {
    if (!has$1.call(formats.formatters, opts.format)) {
      throw new TypeError('Unknown format option provided.');
    }

    format = opts.format;
  }

  var formatter = formats.formatters[format];
  var filter = defaults.filter;

  if (typeof opts.filter === 'function' || isArray$1(opts.filter)) {
    filter = opts.filter;
  }

  return {
    addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
    allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
    charset: charset,
    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
    delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
    encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
    encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
    encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
    filter: filter,
    format: format,
    formatter: formatter,
    serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
    skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
    sort: typeof opts.sort === 'function' ? opts.sort : null,
    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
  };
};

var stringify_1 = function stringify_1(object, opts) {
  var obj = object;
  var options = normalizeStringifyOptions(opts);
  var objKeys;
  var filter;

  if (typeof options.filter === 'function') {
    filter = options.filter;
    obj = filter('', obj);
  } else if (isArray$1(options.filter)) {
    filter = options.filter;
    objKeys = filter;
  }

  var keys = [];

  if (_typeof_1(obj) !== 'object' || obj === null) {
    return '';
  }

  var arrayFormat;

  if (opts && opts.arrayFormat in arrayPrefixGenerators) {
    arrayFormat = opts.arrayFormat;
  } else if (opts && 'indices' in opts) {
    arrayFormat = opts.indices ? 'indices' : 'repeat';
  } else {
    arrayFormat = 'indices';
  }

  var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

  if (!objKeys) {
    objKeys = Object.keys(obj);
  }

  if (options.sort) {
    objKeys.sort(options.sort);
  }

  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];

    if (options.skipNulls && obj[key] === null) {
      continue;
    }

    pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset));
  }

  var joined = keys.join(options.delimiter);
  var prefix = options.addQueryPrefix === true ? '?' : '';

  if (options.charsetSentinel) {
    if (options.charset === 'iso-8859-1') {
      // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
      prefix += 'utf8=%26%2310003%3B&';
    } else {
      // encodeURIComponent('✓')
      prefix += 'utf8=%E2%9C%93&';
    }
  }

  return joined.length > 0 ? prefix + joined : '';
};

var has$2 = Object.prototype.hasOwnProperty;
var isArray$2 = Array.isArray;
var defaults$1 = {
  allowDots: false,
  allowPrototypes: false,
  arrayLimit: 20,
  charset: 'utf-8',
  charsetSentinel: false,
  comma: false,
  decoder: utils.decode,
  delimiter: '&',
  depth: 5,
  ignoreQueryPrefix: false,
  interpretNumericEntities: false,
  parameterLimit: 1000,
  parseArrays: true,
  plainObjects: false,
  strictNullHandling: false
};

var interpretNumericEntities = function interpretNumericEntities(str) {
  return str.replace(/&#(\d+);/g, function ($0, numberStr) {
    return String.fromCharCode(parseInt(numberStr, 10));
  });
};

var parseArrayValue = function parseArrayValue(val, options) {
  if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
    return val.split(',');
  }

  return val;
}; // This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.


var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.

var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
  var obj = {};
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
  var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
  var parts = cleanStr.split(options.delimiter, limit);
  var skipIndex = -1; // Keep track of where the utf8 sentinel was found

  var i;
  var charset = options.charset;

  if (options.charsetSentinel) {
    for (i = 0; i < parts.length; ++i) {
      if (parts[i].indexOf('utf8=') === 0) {
        if (parts[i] === charsetSentinel) {
          charset = 'utf-8';
        } else if (parts[i] === isoSentinel) {
          charset = 'iso-8859-1';
        }

        skipIndex = i;
        i = parts.length; // The eslint settings do not allow break;
      }
    }
  }

  for (i = 0; i < parts.length; ++i) {
    if (i === skipIndex) {
      continue;
    }

    var part = parts[i];
    var bracketEqualsPos = part.indexOf(']=');
    var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
    var key, val;

    if (pos === -1) {
      key = options.decoder(part, defaults$1.decoder, charset, 'key');
      val = options.strictNullHandling ? null : '';
    } else {
      key = options.decoder(part.slice(0, pos), defaults$1.decoder, charset, 'key');
      val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function (encodedVal) {
        return options.decoder(encodedVal, defaults$1.decoder, charset, 'value');
      });
    }

    if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
      val = interpretNumericEntities(val);
    }

    if (part.indexOf('[]=') > -1) {
      val = isArray$2(val) ? [val] : val;
    }

    if (has$2.call(obj, key)) {
      obj[key] = utils.combine(obj[key], val);
    } else {
      obj[key] = val;
    }
  }

  return obj;
};

var parseObject = function parseObject(chain, val, options, valuesParsed) {
  var leaf = valuesParsed ? val : parseArrayValue(val, options);

  for (var i = chain.length - 1; i >= 0; --i) {
    var obj;
    var root = chain[i];

    if (root === '[]' && options.parseArrays) {
      obj = [].concat(leaf);
    } else {
      obj = options.plainObjects ? Object.create(null) : {};
      var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
      var index = parseInt(cleanRoot, 10);

      if (!options.parseArrays && cleanRoot === '') {
        obj = {
          0: leaf
        };
      } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
        obj = [];
        obj[index] = leaf;
      } else {
        obj[cleanRoot] = leaf;
      }
    }

    leaf = obj;
  }

  return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
  if (!givenKey) {
    return;
  } // Transform dot notation to bracket notation


  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey; // The regex chunks

  var brackets = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g; // Get the parent

  var segment = options.depth > 0 && brackets.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key; // Stash the parent if it exists

  var keys = [];

  if (parent) {
    // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
    if (!options.plainObjects && has$2.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }

    keys.push(parent);
  } // Loop through children appending to the array until we hit depth


  var i = 0;

  while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
    i += 1;

    if (!options.plainObjects && has$2.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }

    keys.push(segment[1]);
  } // If there's a remainder, just add whatever is left


  if (segment) {
    keys.push('[' + key.slice(segment.index) + ']');
  }

  return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
  if (!opts) {
    return defaults$1;
  }

  if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
    throw new TypeError('Decoder has to be a function.');
  }

  if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
  }

  var charset = typeof opts.charset === 'undefined' ? defaults$1.charset : opts.charset;
  return {
    allowDots: typeof opts.allowDots === 'undefined' ? defaults$1.allowDots : !!opts.allowDots,
    allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults$1.allowPrototypes,
    arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults$1.arrayLimit,
    charset: charset,
    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$1.charsetSentinel,
    comma: typeof opts.comma === 'boolean' ? opts.comma : defaults$1.comma,
    decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults$1.decoder,
    delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults$1.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : defaults$1.depth,
    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
    interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults$1.interpretNumericEntities,
    parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults$1.parameterLimit,
    parseArrays: opts.parseArrays !== false,
    plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults$1.plainObjects,
    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$1.strictNullHandling
  };
};

var parse = function parse(str, opts) {
  var options = normalizeParseOptions(opts);

  if (str === '' || str === null || typeof str === 'undefined') {
    return options.plainObjects ? Object.create(null) : {};
  }

  var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
  var obj = options.plainObjects ? Object.create(null) : {}; // Iterate over the keys and setup the new object

  var keys = Object.keys(tempObj);

  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
    obj = utils.merge(obj, newObj, options);
  }

  return utils.compact(obj);
};

var lib = {
  formats: formats,
  parse: parse,
  stringify: stringify_1
};

var InterceptorManager = /*#__PURE__*/function () {
  function InterceptorManager() {
    classCallCheck(this, InterceptorManager);

    this.handlers = [];
  }

  createClass(InterceptorManager, [{
    key: "use",
    value: function use(resolve, reject) {
      this.handlers.push({
        resolve: resolve,
        reject: reject
      });
      var interceptorId = this.handlers.length - 1;
      return interceptorId;
    }
  }, {
    key: "eject",
    value: function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    }
  }, {
    key: "forEach",
    value: function forEach(fn) {
      this.handlers.forEach(function (item) {
        fn(item);
      });
    }
  }]);

  return InterceptorManager;
}();

var instanceMap = {};

function composeInterceptorChain(interceptor, request) {
  var chain = [request, undefined];
  interceptor.request.forEach(function (_ref14) {
    var resolve = _ref14.resolve,
        reject = _ref14.reject;
    chain.unshift(resolve, reject);
  });
  interceptor.response.forEach(function (_ref15) {
    var resolve = _ref15.resolve,
        reject = _ref15.reject;
    chain.push(resolve, reject);
  });
  return chain;
}

function copyConfigProperty(conf, globalData) {
  var ret = {};
  var neededProperty = ["method", "headers", "credentials", "body"];

  if (conf.data && conf.body == null) {
    conf.body = conf.data;
  }

  if (_typeof_1(conf.body) === "object") {
    conf.body = JSON.stringify(conf.body);
  }

  neededProperty.forEach(function (prop) {
    ret[prop] = conf[prop];
  });

  if (conf.extra && conf.extra.deviceId && globalData && globalData.lizhi && globalData.lizhi.appInfo) {
    ret.headers = _objectSpread$1({
      deviceId: globalData.lizhi.appInfo.deviceId
    }, ret.headers);
  }

  return ret;
}

var Fetch = /*#__PURE__*/function () {
  function Fetch() {
    var componentName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var aid = arguments.length > 1 ? arguments[1] : undefined;
    var globalData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    classCallCheck(this, Fetch);

    this.componentName = componentName;
    this.aid = aid;
    this.globalData = globalData;
    this.interceptor = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }

  createClass(Fetch, [{
    key: "request",
    value: function request(conf) {
      var _this9 = this;

      var request = function request(conf) {
        var host = window.location.host;
        var path = "/" + _this9.aid + "/" + _this9.componentName + conf.url;
        var protocol = "//";

        if (conf.host) {
          host = conf.host;
        }

        if (conf.absUrl) {
          path = conf.absUrl;
        }

        if (conf.protocol) {
          protocol = conf.protocol;
        }

        var url = "".concat(protocol).concat(host).concat(path, "?").concat(lib.stringify(conf.params, {
          arrayFormat: conf.arrayFormat
        }));
        var option = copyConfigProperty(conf, _this9.globalData);
        return fetch$1(url, option).then(function (res) {
          return res.json();
        });
      };

      var chain = composeInterceptorChain(this.interceptor, request);
      var promise = Promise.resolve(conf);

      while (chain.length) {
        promise = promise.then(chain.shift(), chain.shift());
      }

      return promise;
    }
  }]);

  return Fetch;
}();

function createRequest(vm) {
  var componentName; // 如果不传 vm 进来，那可以获取到多个实例

  try {
    componentName = vm.$options.componentName;
  } catch (e) {}

  if (instanceMap[componentName]) {
    return Promise.resolve(instanceMap[componentName]);
  }

  return getStore(vm).then(function (_ref16) {
    var globalData = _ref16.globalData;
    var instance = new Fetch(componentName, globalData.id, globalData);

    if (componentName) {
      instanceMap[componentName] = instance;
    }

    return instance;
  });
}

var APP = process.env.APP || window.APP;
var SERVER_ENV$1 = process.env.SERVER_ENV || window.SERVER_ENV;

var upload = function upload(file) {
  if (/pongpong/i.test(APP)) {
    return uploadToCustom(file);
  } else if (/zhiya|tiya/i.test(APP)) {
    return uploadToCustom(file, {
      uploadType: 24,
      picType: 0
    });
  }

  return fetch('/api/activity/innerToken', {
    credentials: 'same-origin'
  }).then(function (res) {
    return res.json();
  }).then(function (result) {
    if (!result.code === 0) {
      throw new Error(result);
    }

    var innerToken = result.data;
    var config = {
      file: file,
      bizId: 2,
      innerToken: innerToken
    }; // docker环境

    if (SERVER_ENV$1 === 'docker') {
      config.domain = 'webupload.yfxn.lizhi.fm';
    } else if (SERVER_ENV$1 === 'pre') {
      // 预发
      config.domain = 'webuploadpre.lizhi.fm';
    } else {
      // 正式环境
      config.domain = 'webupload.lizhi.fm';
    }

    config.domain = "".concat(location.protocol, "//").concat(config.domain);
    var uploader = new Uploader(config);
    return uploader.toInner();
  });
};

function uploadToCustom(file) {
  var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var uploader = new Uploader({
    file: file
  });
  return uploader.toCustom("/grootServer/uploadProxy?APP=".concat(APP), extraData);
}
/**
 * 将url上的query参数拼接到指定的url上
 * @param {string} url 需要拼接的url
 * @return {string}
 */


var joinQueryString = function joinQueryString(url) {
  var search = location.search;

  if (!search) {
    return url;
  } // 去除search的hash部分


  search = search.split('#')[0]; // 检测原链接是已经包含参数

  if (url.includes('?')) {
    return "".concat(url, "&").concat(search.slice(1));
  } else {
    return "".concat(url).concat(search);
  }
};

var parseQuery = function parseQuery(url) {
  var obj = {};
  url.replace(/([^?&=]+)=([^&]+|[^&]?)/g, function (_, k, v) {
    return obj[k] = decodeURIComponent(v);
  });
  return obj;
};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */


var FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */

var INFINITY$1$1 = 1 / 0;
/** `Object#toString` result references. */

var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag$1$1 = '[object Symbol]';
/** Used to match property names within property paths. */

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */

var freeGlobal$1$1 = _typeof_1(commonjsGlobal$1) == 'object' && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;
/** Detect free variable `self`. */

var freeSelf$1$1 = (typeof self === "undefined" ? "undefined" : _typeof_1(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root$1$1 = freeGlobal$1$1 || freeSelf$1$1 || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue(object, key) {
  return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */


function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;

  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }

  return result;
}
/** Used for built-in method references. */


var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto$1$1 = Object.prototype;
/** Used to detect overreaching core-js shims. */

var coreJsData = root$1$1['__core-js_shared__'];
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */


var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto$1$1.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString$1$1 = objectProto$1$1.toString;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */

var Symbol$2 = root$1$1.Symbol,
    splice = arrayProto.splice;
/* Built-in method references that are verified to be native. */

var Map = getNative(root$1$1, 'Map'),
    nativeCreate = getNative(Object, 'create');
/** Used to convert symbols to primitives and strings. */

var symbolProto$1$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolToString$1$1 = symbolProto$1$1 ? symbolProto$1$1.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */


function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function hashGet(key) {
  var data = this.__data__;

  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }

  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */


function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
} // Add methods to `Hash`.


Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */


function listCacheClear() {
  this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */


function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
} // Add methods to `ListCache`.


ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */


function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */


function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
} // Add methods to `MapCache`.


MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */


function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }

  return index && index == length ? object : undefined;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */


function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */


function baseToString$1$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isSymbol$1$1(value)) {
    return symbolToString$1$1 ? symbolToString$1$1.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1$1 ? '-0' : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */


function castPath(value) {
  return isArray$3(value) ? value : stringToPath(value);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */


function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */


function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */


function isKey(value, object) {
  if (isArray$3(value)) {
    return false;
  }

  var type = _typeof_1(value);

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol$1$1(value)) {
    return true;
  }

  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */


function isKeyable(value) {
  var type = _typeof_1(value);

  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */


var stringToPath = memoize(function (string) {
  string = toString$1$1(string);
  var result = [];

  if (reLeadingDot.test(string)) {
    result.push('');
  }

  string.replace(rePropName, function (match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey(value) {
  if (typeof value == 'string' || isSymbol$1$1(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1$1 ? '-0' : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */


function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */


function memoize(func, resolver) {
  if (typeof func != 'function' || resolver && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };

  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
} // Assign cache to `_.memoize`.


memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq(value, other) {
  return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */


var isArray$3 = Array.isArray;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString$1$1.call(value) : '';
  return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject(value) {
  var type = _typeof_1(value);

  return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike$1$1(value) {
  return !!value && _typeof_1(value) == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */


function isSymbol$1$1(value) {
  return _typeof_1(value) == 'symbol' || isObjectLike$1$1(value) && objectToString$1$1.call(value) == symbolTag$1$1;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */


function toString$1$1(value) {
  return value == null ? '' : baseToString$1$1(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */


function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var lodash_get = get;
var PropertyMixin = {
  watch: {
    currentEditInstanceKey: function currentEditInstanceKey(n, o) {
      // init
      this.initCurrtField();
      this.validField(this.form.value);
    },
    value: function value(n, o) {
      this.setInstanceProps(n);
    },
    'form.value': function formValue(n) {
      // this.valid 在 mounted 的时候会验证一次，这时候凭借这这个值来决定是否要监听值变化随时变化。
      if (this.valid === false) {
        this.validField(n);
      } else {
        this.setInstanceProps(n);
      }
    }
  },
  props: {
    instanceInfo: Object,
    editor: Object,
    editInstanceKey: String,
    customEditorRule: Object,
    inSlot: Boolean
  },
  data: function data() {
    return {
      value: void 0,
      valid: false,
      instanceKey: '',
      form: {
        value: void 0
      }
    };
  },
  computed: _objectSpread$1(_objectSpread$1({}, mapGetters({
    currentPageEditInstanceKey: 'viewport/currentEditInstanceKey',
    validStatus: 'viewport/validStatus'
  })), {}, {
    currentEditInstanceKey: function currentEditInstanceKey() {
      return this.editInstanceKey || this.currentPageEditInstanceKey;
    },
    field: function field() {
      return this.editor.field;
    },
    rule: function rule() {
      var rule = this.customEditorRule || this.editor.rule;

      if (rule == null || rule.type == null && rule.validator == null) {
        return null;
      }

      var value = [];

      if (Array.isArray(rule)) {
        value = value.concat[rule];
      } else {
        value = [rule];
      }

      return {
        value: value
      };
    },
    mergeStyle: function mergeStyle() {
      var style = this.style || {};
      return _objectSpread$1({
        flex: 1,
        'margin': '0 0 0 10px'
      }, style);
    }
  }),
  methods: {
    setInstanceProps: function setInstanceProps(value) {
      this.$store.commit('viewport/setInstanceProps', {
        instanceKey: this.instanceKey,
        key: this.field,
        value: value
      });

      if (this.inSlot) {
        this.$emit('change:value', this.field, value);
      }
    },
    initCurrtField: function initCurrtField() {
      var val = lodash_get(this.instanceInfo.data, this.field);

      if (typeof val === 'undefined' && typeof this.editor["default"] !== 'undefined') {
        val = this.editor["default"];
      } // iview 颜色插件有bug，不接受undefined和null的值


      if (this.editor.type === 'color') {
        val = val || '';
      }

      this.instanceKey = this.currentEditInstanceKey;
      this.value = val;
      this.form.value = val;
    },
    validField: function validField(n) {
      var _this10 = this;

      this.setInstanceProps(n);

      if (this.$refs.form == null || this.rule == null || this.rule.length === 0) {
        return;
      }

      this.$refs.form.validate(function (valid, errors) {
        _this10.$store.commit('viewport/saveValidateResult', {
          value: n,
          errors: errors,
          valid: valid,
          field: _this10.editor.field,
          instanceKey: _this10.instanceKey
        });
      });
    },
    getCurrentEditorValidStatus: function getCurrentEditorValidStatus() {
      var status;

      try {
        status = this.validStatus[this.instanceKey][this.editor.field];

        if (status == null) {
          return true;
        }
      } catch (e) {
        return true;
      }

      return status.valid;
    },
    __init: function __init() {
      this.valid = this.getCurrentEditorValidStatus();

      if (this.field) {
        this.initCurrtField();

        if (this.valid === false) {
          this.validField(this.form.value);
        }
      }
    }
  },
  created: function created() {
    this.__init();
  },
  // 在 beforeDestry 之前验证是因为如果 trigger 是 blur，就没有可用的验证时机(因为没有提交表单之类的交互)，只能借助这个钩子
  beforeDestroy: function beforeDestroy() {// this.validField(this.form.value)
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
function splitEditorConfig(editorConfigList, componentProps) {
  var editorProps = [];

  for (var i = 0; i < editorConfigList.length; i++) {
    var item = editorConfigList[i];
    var propName = item.propName,
        propNameList = item.propNameList,
        editorType = item.editorType,
        editorComponent = item.editorComponent,
        desc = item.desc,
        data = item.data,
        rule = item.rule;
    var compProp = componentProps[propName];

    if (compProp == null && editorType !== EDITOR_TYPE.NAMED_SLOT && editorType !== EDITOR_TYPE.CUSTOM) {
      continue;
    }

    var editorConf = {
      text: desc,
      type: editorType,
      data: data
    }; // 如果组件声明里没这个属性
    // 且此属性对应的不是 named_slot
    // 则忽略

    if (compProp == null) {
      // 如果不是带 propNameList 的 custom 或者 named_slot，也忽略
      var isSpecialType = editorType === EDITOR_TYPE.CUSTOM && propNameList && propNameList.length > 0 || editorType === EDITOR_TYPE.NAMED_SLOT && data && data.slotName;

      if (isSpecialType === false) {
        continue;
      }
    }

    if (editorType === EDITOR_TYPE.NAMED_SLOT) {
      if (data == null) {
        throw Error('EDITOR_TYPE.NAMED_SLOT 的 editorConfig 必须携带 data');
      }

      editorProps.push(editorConf);
      continue;
    }

    if (propNameList && propNameList.length) {
      editorConf.fieldList = propNameList.filter(function (propName) {
        if (_typeof_1(propName) === 'object') {
          return propName.propName && propName.slotName && componentProps[propName.propName];
        }

        return propName && componentProps[propName];
      }).map(function (propName) {
        if (_typeof_1(propName) === 'object' && propName.slotName) {
          var _compProp = componentProps[propName.propName];
          return {
            type: propName.editorType,
            data: propName.data,
            field: getEditorField(propName.propName),
            "default": propName.editorType === EDITOR_TYPE.COLOR ? _compProp["default"] || '' : _compProp["default"],
            slotName: propName.slotName
          };
        }

        return {
          field: getEditorField(propName),
          "default": componentProps[propName]["default"]
        };
      });
    } else {
      editorConf.field = getEditorField(propName); // iview有个Bug,如果默认值为undefined或者null，COLOR组件会报错，给个空字符串就不会了

      editorConf["default"] = editorType === EDITOR_TYPE.COLOR ? compProp["default"] || '' : compProp["default"];
    }

    if (editorType === EDITOR_TYPE.CUSTOM) {
      editorConf.component = editorComponent;
    } else {
      editorConf.field = editorConf.field || editorConf.fieldList[0];

      if (_typeof_1(editorConf.field) === 'object') {
        editorConf.field = editorConf.field.field;
      }

      editorConf.rule = rule || {};
    }

    editorProps.push(editorConf);
  }

  return editorProps;
}
var Register = registerFactory(TAG_PRESET, ABANDONED_TAG);
var GrootRegister = /*#__PURE__*/function (_Register) {
  inherits(GrootRegister, _Register);

  var _super = _createSuper(GrootRegister);

  function GrootRegister(conf) {
    classCallCheck(this, GrootRegister);

    return _super.call(this, conf);
  }

  createClass(GrootRegister, [{
    key: "createModule",
    value: function createModule(componentProps) {
      var editorConfigList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var key = composeComponentName(this.tag, this.componentName);

      var property = _objectSpread$2(_objectSpread$2({
        key: key
      }, this.usage), {}, {
        usage: _objectSpread$2({
          tag: this.tag
        }, this.usage),
        tag: lodash_kebabcase(key),
        editors: splitEditorConfig(editorConfigList, componentProps),
        hidden: opt.hidden
      });

      return {
        property: property
      };
    }
  }]);

  return GrootRegister;
}(Register);

function copyObjWithValue(o, val) {
  var ret = {};

  for (var k in o) {
    ret[k] = typeof val === 'function' ? val(k) : val[k];
  }

  return ret;
}

var THEME_COLOR = {
  COLOR_BTN: 'color_btn',
  COLOR_BTN_TEXT: 'color_btn_text',
  COLOR_BACKGROUND_TEXT: 'color_background_text',
  COLOR_CONTENT_BACKGROUND: 'color_content_background',
  COLOR_ALL_BACKGROUND: 'color_all_background',
  COLOR_LINE: 'color_line',
  COLOR_EXCHANGE_BACKGROUND: 'color_exchange_background',
  COLOR_CONTENT_LINE: 'color_content_line'
};
function themeMixin(color_map) {
  var dataKey = "s_".concat((Math.random() * 1000).toString(16).replace('.', ''));
  return {
    props: {
      themeColor: {
        type: Object
      }
    },
    data: function data() {
      var _this = this;

      var propChangeDetect = function propChangeDetect(obj) {
        var originProps = _this.$vnode.componentOptions.Ctor.options.props;

        if (!originProps) {
          return obj;
        }

        var newData = {};

        for (var _i = 0, _Object$entries = Object.entries(obj); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = slicedToArray(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              value = _Object$entries$_i[1];

          var currentOriginProps = originProps[key];

          if (!currentOriginProps) {
            newData[key] = value;
          } else {
            var originPropsDefaultValue = typeof currentOriginProps["default"] === 'function' ? currentOriginProps["default"]() : currentOriginProps["default"]; // 如果props的值和默认值不致，表示props有更改过，则使用props的值

            if (originPropsDefaultValue !== _this[key]) {
              newData[key] = _this[key];
            } else {
              newData[key] = value;
            }
          }
        }

        return newData;
      };

      return defineProperty({}, dataKey, propChangeDetect(copyObjWithValue(color_map, '')));
    },
    computed: {
      priorityColorData: function priorityColorData() {
        var _this2 = this;

        return Object.keys(color_map).reduce(function (obj, key) {
          /** 这里的逻辑是：
           * 如果组件的颜色有更改过，则取组件颜色的值 this[dataKey][key]
           * 如果组件没有更改过，则使用主题色
           * 如果没有主题色，则使用props的值
           */
          var themeKey = color_map[key];
          obj[key] = _this2[dataKey][key] || _this2.themeColor && _this2.themeColor[themeKey] || _this2[key];
          return obj;
        }, {});
      }
    },
    watch: copyObjWithValue(color_map, function (k) {
      return function (nv) {
        this[dataKey][k] = nv;
      };
    })
  };
}

function getRegister(conf) {
  return new GrootRegister(conf);
}

export { EDITOR_TYPE, EVENT_TYPE, PropertyMixin, TAG_PRESET, THEME_COLOR, appInvoker, composeComponentName, emitEvent, getEditorField, getRegister, createRequest as getRequest, getSensors, getStore, initLz, initStore, joinQueryString, proxy as lz, offEvent, onEvent, parseQuery, parseScrollLS, parseScrollQuery, registerFactory, reportEvent, themeMixin, upload };
